//objeto para el editor de apuestas
//************************************************************************************************************************************************************************************************
// var sufflePressed = false;
var numberChooser = function(options, disableNonMultipleSymmaryCallback, enableNonMultipleSummaryCallback, anyColumnDoneCallback, firstColumnDoneCallback, anyColumnIncompleteCallback, anyColumnEmptyCallback, oneNumberSelectedCallback, clickedMultipleCallback) {
	var isQuiniela = false;

	this.hasSession = false;
	this.betsPerTicket = 8;
	this.betsToChooseSN=6;
	this.betsToChooseML=10;
	this.maxBetsForDirectML=false; 							//Sólo se usa como backup de betsToChooseML, porque se sustituye su valor con el máximo de reducciónes
	this.maxExtrasForDirectML=false; 							//Sólo se usa como backup de betsToChooseML, porque se sustituye su valor con el máximo de reducciónes
	this.allowsMultipleWithLess=false; 						//Sólo se usa para indicar que Primitiva y Bonoloto permiten múltiples de 5 números
	this.minBetsPerTicket = 1;
	this.minNumerosReduccion = false;
	this.maxNumerosReduccion = false;
	this.maxExtrasReduccion = false;

	this.growingBetsMode=false;								//Si no se permiten multiples, entonces capamos por num de numeros marcados, juegos tipo lotto hotpicks,
	this.minNumeros=1;										//Sólo se usan cuando no se permitan las múltiples
	this.maxNumeros=5;

	this.isReducidaInProgress = false;
	this.isMultipleInProgress = false;
	this.isCondicionadaInProgress = false;
	this.isSetToMultiple = false;							//Para forzar desde fuera que estamos en un modo concreto, aunque los números no digan aún si es multiple o no
	this.isSetToReducida = false;							//Para forzar desde fuera que estamos en un modo concreto, aunque los números no digan aún si es reducida o no
	this.isSetToCondicionada = false;						//Para forzar desde fuera que estamos en un modo concreto, aunque los números no digan aún si es condicionada o no
	this.isShuffleInProgress = false;
	this.isClearingInProgress = false;
	this.isMultipleWithLessInProgress=false;				//Determina si esta activo el modo en el que un boleto es múltiple con 5 números

	this.currentRow = 0;
	this.currentBet = 0;
	this.correctBets = 0;
	this.apuestas=0;
	this.incompleteBets = 0;
	this.hasBetsAfterFirst=false;
	this.lastPressedElement = false;
	this.revertClickAction = false;
	this.multipleChecked = 0;


	this.numbers = [];
	this.extras = [];
	this.hasExtras = false;
	this.hasExtrasOut = false;
	this.extrasName = false;
	this.indexExtraOut = -1;
	this.indexExtraCompl = -1;
	this.escrutinio = false;
	this.extrasUnique = false;
	this.type = "bonoloto";
	this.tipoSorteo = 1;
	this.id_sorteo = 684;
	this.addToSummary = true;
	this.ignoreCookies = false;
	this.allowsRandom = false;
	this.allowsDelete = false;
	this.ignorePagerClicksOnDesktop = false;

	this.isCompactMode = false; //calculamos si estamos en modo compacto para gestionar diferente la paginacion y columnas activas
	this.numbersChoserSummaryElem = "#numbersChoserSummary"

	this.rawApuesta = new Array();
	this.multipleRawValues = {};

	var parentObj = this;
	this.maxBetsForDirectML = this.betsToChooseML ;

	this.completeButIncompleteExtras = false
	this.incompleteP15 = false;

	this.allowMultiple = options?.allowMultiple ?? false;

	this.onResetBoletoCallback=function(){};
	this.onTodasColumnasCompletadasCallback=function(choserObj){};
	this.onClickedMultipleCallback=function(){}
	this.onOneNumberSelectedCallback=function(){}

	this.onEnableNonMultipleSummaryCallback=function(){}
	this.onDisableNonMultipleSummaryCallback=function(){}
	this.onFirstColumnDoneCallback=function(){}
	this.onAnyColumnDoneCallback=function(){}
	this.onAnyColumnEmptyCallback=function(){}
	this.onRandomCallback = function(){}
	this.onAnyCompletedColumnExceptExtrasCallback = function(){}
	this.onColumnaCompletadaPteSeleccionMultiple = function(){} //Se lanza cuando es una multiple con menos (bonoloto, primitiva) y está completada pero hay que mover al sistema de multiples
	this.onNumberPressedCallback = function(){} //Se envía al callback el siguiente objeto:
												//function(e,j)
												//e = {
												//		numbers:3,
												//		remaining:2,
												//		extras:0,
												//		remaining:0
												//	}
												//j = la instancia de esta clase
	this.progressiveColumns = false;
	this.boletoSnapshot = {}
/*
	{
		"0":{ //Columna
			status: 0 (vacio) || 1 (valido) || 2 (incompleto)
		},
		"1":{
			...
		}
	}
*/
	if (options.type == "bonoloto" || options.type == "primitiva") {
		this.allowsMultipleWithLess = true;
	} else {
		this.allowsMultipleWithLess = false;
	}
	this.allowsMultipleWithLessBackup = this.allowsMultipleWithLess;
	if(!this.allowMultiple){
		this.allowsMultipleWithLess = false;
	}

	if (options.type == "quiniela")		{
		this.isQuiniela = true;
		this.resultados = options.resultados;
		this.premios = options.premios;
	}
	if (options.type == "quinigol")		{
		this.isQuinigol = true;
		this.resultados = options.resultados;
		this.premios = options.premios;
	}
	if (options.hasExtras == true)	{
		this.hasExtras = true;
	}
	if (options.hasExtrasOut == true)	{ // Si se ponen hasExtraOut a true, deben facilitarse extrasToChooseSN y extrasToChooseML
		this.hasExtrasOut = true;
		this.extrasToChooseSN = options.extrasToChooseSN;
		this.extrasToChooseML = options.extrasToChooseML;
		this.extrasUnique = options.extrasUnique;

		if (typeof options.maxExtrasReduccion != "undefined")	{
			this.maxExtrasReduccion = options.maxExtrasReduccion
			this.maxExtrasForDirectML = this.extrasToChooseML;
			this.extrasToChooseML = this.maxExtrasReduccion ;
		}else{
			this.maxExtrasReduccion = this.extrasToChooseML;
			this.maxExtrasForDirectML = this.extrasToChooseML;
		}

		if( typeof options.extrasName != "undefined"){
			this.extrasName = options.extrasName;
		}

	} else {
		this.hasExtraOut = false;
		this.extrasUnique = false;
	}
	if (options.betsPerTicket)			{	this.betsPerTicket = options.betsPerTicket }
	if (options.betsToChooseSN)			{	this.betsToChooseSN = options.betsToChooseSN }
	if (options.betsToChooseML)			{
		this.betsToChooseML = options.betsToChooseML;
		this.maxBetsForDirectML = this.betsToChooseML;
	}
	if (typeof options.minNumerosReduccion != "undefined")	{
		this.minNumerosReduccion = options.minNumerosReduccion
	}
	if (typeof options.maxNumerosReduccion != "undefined")	{
		this.maxNumerosReduccion = options.maxNumerosReduccion
		this.betsToChooseML = this.maxNumerosReduccion ;
	}

	if(typeof options.growingBetsMode != "undefined"){
		this.growingBetsMode = options.growingBetsMode
		if(typeof options.minNumeros != "undefined"){
			this.minNumeros=options.minNumeros;
			this.betsToChooseSN = options.minNumeros
		}
		if(typeof options.maxNumeros != "undefined"){
			this.maxNumeros=options.maxNumeros;
			this.betsToChooseML =options.maxNumeros
		}
	}

	if(typeof options.onAnyCompletedColumnExceptExtrasCallback != "undefined"){	this.onAnyCompletedColumnExceptExtrasCallback = options.onAnyCompletedColumnExceptExtrasCallback}
	if(typeof options.onColumnaCompletadaPteSeleccionMultiple != "undefined"){	this.onColumnaCompletadaPteSeleccionMultiple = options.onColumnaCompletadaPteSeleccionMultiple}


	if (options.minBetsPerTicket)		{	this.minBetsPerTicket = options.minBetsPerTicket }
	if (options.numbers)				{	this.numbers = options.numbers }
	if (options.extras)					{	this.extras = options.extras }
	if (options.indexExtraOut != -1)	{	this.indexExtraOut = options.indexExtraOut }
	if (options.indexExtraCompl != -1)	{	this.indexExtraCompl = options.indexExtraCompl }
	if (options.escrutinio)				{	this.escrutinio = options.escrutinio }
	if (options.type)					{	this.type = options.type }
	if (options.tipoSorteo)				{	this.tipoSorteo = options.tipoSorteo }
	if (options.hasSession)				{	this.hasSession = options.hasSession; }
	if (options.id_sorteo)				{	this.id_sorteo = options.id_sorteo; }
	if (options.allowsRandom)			{	this.allowsRandom = options.allowsRandom; }
	if (options.allowsDelete)			{	this.allowsDelete = options.allowsDelete; }
	if (options.ignorePagerClicksOnDesktop)	{	this.ignorePagerClicksOnDesktop = options.ignorePagerClicksOnDesktop; }
	if (typeof options.addToSummary != "undefined") {	this.addToSummary = options.addToSummary; }
	if (typeof options.ignoreCookies != "undefined") {	this.ignoreCookies = options.ignoreCookies; }
	if (options.onResetBoletoCallback)	{	this.onResetBoletoCallback = options.onResetBoletoCallback; }
	if (options.onTodasColumnasCompletadasCallback)	{	this.onTodasColumnasCompletadasCallback = options.onTodasColumnasCompletadasCallback; }
	if (options.onRandomCallback)	{	this.onRandomCallback = options.onRandomCallback; }
	if (typeof options.onNumberPressedCallback !="undefined")		{	this.onNumberPressedCallback = options.onNumberPressedCallback; } //Cuando se presiona un número. Devuelve cuantos hay marcados, cuantos quedan para apuesta, cuantos extras hay y cuantos quedan.

	if (typeof clickedMultipleCallback!="undefined"){
		this.onClickedMultipleCallback=clickedMultipleCallback; //Necesario para guardar referencias y recoger valores del chooser, para refrescar los valores al alternar en diferentes modos multiples
	}
	if (typeof oneNumberSelectedCallback!="undefined"){ this.onOneNumberSelectedCallback=oneNumberSelectedCallback;	}
	if (typeof enableNonMultipleSummaryCallback!="undefined"){ this.onEnableNonMultipleSummaryCallback=enableNonMultipleSummaryCallback;	}
	if (typeof disableNonMultipleSymmaryCallback!="undefined"){ this.onDisableNonMultipleSummaryCallback=disableNonMultipleSymmaryCallback;	}

	if (typeof firstColumnDoneCallback!="undefined"){ this.onFirstColumnDoneCallback=firstColumnDoneCallback;	}
	if (typeof anyColumnDoneCallback!="undefined"){ this.onAnyColumnDoneCallback=anyColumnDoneCallback;	}
	if (typeof anyColumnEmptyCallback!="undefined"){ this.onAnyColumnEmptyCallback=anyColumnEmptyCallback;	}


	$('.numbersChoserPages li').removeClass('active');
	updateNumbersPager();
	$("#guardar").removeAttr("data-open");
	$("[data-bt_navBoleto_Left]").addClass("disabled").attr('aria-disabled',true);

	var checkColumnasCompletadasCache = false;

	//Calculamos si estamos en modo compacto o no
	this.checkModeLayout();
	if(this.progressiveColumns){
		parentObj.blockAllColumns(0); //Si se activa el modo de desbloqueo progresivo de columnas, bloqueamos todas menos la primera
	}

	for(i=0;i<this.betsPerTicket;i++){
		this.boletoSnapshot[i] = {
			status: 0
		}
	}

	if (this.isQuiniela || this.isQuinigol) {
		this.firstPlayableCol = $('[data-quinielacolumn]:eq(0)').index()
	}

	// Clic en un número del boleto
	$(document).off("change",'[data-numbersChoser] .row .column input,[data-quinielacolumn] input').on("change",'[data-numbersChoser] .row .column input,[data-quinielacolumn] input',function(){
// 	$('[data-numbersChoser] .row .column,[data-quinielacolumn]').on("change","input",function(){
// 	$('[data-numbersChoser] .row .column input, [data-quinielacolumn] input').change(function() {
		//	Para sorteos de números
		if (!parentObj.isQuiniela && !parentObj.isQuinigol) {
			var betsOrExtrasToChoseSN = 0;
			var betsOrExtrasToChoseML = 0;
			var isNumberOrExtra = "";
			parentObj.lastPressedElement = $(this);

			if ($(this).closest("[data-numberschoser]")[0].hasAttribute("data-extraschooser")) {
				isNumberOrExtra = "extras";
				betsOrExtrasToChoseSN = parentObj.extrasToChooseSN;
				betsOrExtrasToChoseML = parentObj.extrasToChooseML;
			} else {
				isNumberOrExtra = "numbers";
				betsOrExtrasToChoseSN = parentObj.betsToChooseSN;
				betsOrExtrasToChoseML = parentObj.betsToChooseML;
			}

			if (parentObj.growingBetsMode) {
				betsOrExtrasToChoseSN = parentObj.minNumeros
				betsOrExtrasToChoseML = parentObj.maxNumeros
			}




			if( isNumberOrExtra != "extras"){
				parentObj.currentRow = $(this).closest("[data-index]").attr("data-index");
			}

			if(parentObj.allowsMultipleWithLess && $("[data-numberschoser]:not([data-extraschooser])").find(".row:eq(0)").find('input:checked').length == (parentObj.betsToChooseSN - 1)){
// 			if (parentObj.allowsMultipleWithLess && $(this).closest('.row').find('.column.active').length+1 == (betsOrExtrasToChoseSN - 1) && parentObj.currentRow==0){
				parentObj.isMultipleWithLessInProgress=true;
			}else{
				parentObj.isMultipleWithLessInProgress=false;
			}
			updateNumbersPager()

			// Para saber antes de marcar si las múltiples están habilitadas o deshabilitadas.
			var stateIsMultiple = false
			var numbersLength = $("[data-numberschoser]:not([data-extraschooser])").find(".row.active").find('input:checked').length
			var extrasLength = $("[data-extraschooser]").find(".row.active").find('input:checked').length

			if (!parent.allowsMultipleWithLess){
				if(parentObj.hasExtrasOut){
					if(numbersLength > parentObj.betsToChooseSN || extrasLength > parentObj.extrasToChooseSN){
						stateIsMultiple = true
					}
				}else{
					if(numbersLength > parentObj.betsToChooseSN) {
						stateIsMultiple = true
					}
				}

			}else{
				if(parentObj.hasExtrasOut){
					if(numbersLength > parentObj.betsToChooseSN || numbersLength == parentObj.betsToChooseSN - 1 || extrasLength > parentObj.extrasToChooseSN){
						stateIsMultiple = true
					}
				}else{
					if(numbersLength > parentObj.betsToChooseSN || numbersLength == parentObj.betsToChooseSN - 1){
						stateIsMultiple = true
					}
				}
			}
			if(parentObj.growingBetsMode){
				stateIsMultiple = false
			}

			var clickCanBeDone = true;
			// Funcionalidad de marcar y desmarcar los números
			if ( !parentObj.growingBetsMode && ($(this).closest('[data-index]').attr("data-index") == 0 && ($(this).closest('.row').find('.column.active').length < betsOrExtrasToChoseML && parentObj.allowMultiple)||($(this).closest('.row').find('.column.active').length < betsOrExtrasToChoseSN && !parentObj.allowMultiple )) || // Boleto 1 y No Múltiple
				($(this).closest('[data-index]').attr("data-index") != 0 && $(this).closest('[data-numberschoser]').find('.row:eq(0)').find('.column.active').length <= betsOrExtrasToChoseSN && $(this).closest('.row').find('.column.active').length < betsOrExtrasToChoseSN)) {	// Boleto superior al 1 y sin múltiple
				$(this).closest('.column').toggleClass('active');

			} else if (	!parentObj.growingBetsMode && ($(this).closest('[data-index]').attr("data-index") == 0 && ($(this).closest('.row').find('.column.active').length == betsOrExtrasToChoseML) || (!parentObj.allowMultiple && $(this).closest('.row').find('.column.active').length <= betsOrExtrasToChoseSN) ) || // Boleto 1 y Múltiple
						($(this).closest('[data-index]').attr("data-index") != 0 && $(this).closest('[data-numberschoser]').find('.row:eq(0)').find('.column.active').length <= betsOrExtrasToChoseSN) && $(this).closest('.row').find('.column.active').length == betsOrExtrasToChoseSN) { // Boleto superior al 1 y con múltiples

				if (isNumberOrExtra == "extras" && parentObj.hasExtrasOut && parentObj.extrasToChooseML == 1 && !$(this).closest('.column').hasClass("active")) {
					$(this).closest('.row').find('input').prop('checked',false)
					var elementToRemove = $(this).closest('.row').find(".column.active");
					elementToRemove.removeClass("active");
					$(this).closest('.column').toggleClass('active');
				} else {
					var areExtrasUniqueAlreadyChosen = false
					if(isNumberOrExtra == "extras" && parentObj.extrasUnique ){
						 areExtrasUniqueAlreadyChosen = parentObj.areExtrasAlreadyChosen();
					}else if(isNumberOrExtra == "extras" && !parentObj.extrasUnique){
						areExtrasUniqueAlreadyChosen = parentObj.areExtrasAlreadyChosen(parentObj.getActiveColumn());
					}

					if(isNumberOrExtra != "extras" || (isNumberOrExtra == "extras" && !areExtrasUniqueAlreadyChosen)  || (isNumberOrExtra == "extras" && parentObj.extrasToChooseML == 1 && (!areExtrasUniqueAlreadyChosen || areExtrasUniqueAlreadyChosen && parentObj.revertClickAction)) /*Si se ha establecido el extra unico ya, pero se fuerza un -quita y pon- para relanzar los eventos lo tenemos en cuenta */ || (isNumberOrExtra == "extras" && parentObj.extrasToChooseSN > 1 && areExtrasUniqueAlreadyChosen)){
/*
						if (isNumberOrExtra != "extras"){
							if (parentObj.getActiveColumn() != 0 && $(this).closest('.row').find('.column.active').length < betsOrExtrasToChoseSN){
								$(this).closest('.row').find('input').prop('checked',false);
							}else{
								clickCanBeDone = false;
							}
						}else{
*/
							if(isNumberOrExtra == "numbers"){
// 								$(this).prop('checked',false);
								$(this).prop('checked',false).closest('.column').removeClass('active');
							}else{
								if(parentObj.extrasUnique){
									$(this).closest('.row').find('input').prop('checked',false).closest('.column').removeClass('active');
								}else{
									$(this).prop('checked',false).closest('.column').removeClass('active');
								}

							}
// 						}
					}else{
						clickCanBeDone = false;
					}

					if(isNumberOrExtra != "extras" || (isNumberOrExtra == "extras" && !areExtrasUniqueAlreadyChosen) || (isNumberOrExtra == "extras" && parentObj.extrasToChooseSN > 1 && areExtrasUniqueAlreadyChosen)){
						if (isNumberOrExtra != "extras"){
							var numMarcados = $(this).closest('.row').find('.column.active').length;
							if (parentObj.getActiveColumn() != 0 && (numMarcados < betsOrExtrasToChoseSN || (numMarcados == betsOrExtrasToChoseSN && $(this).prop('checked'))) || (parentObj.getActiveColumn() == 0 && !parentObj.allowMultiple && (numMarcados < betsOrExtrasToChoseSN || (numMarcados == betsOrExtrasToChoseSN && $(this).prop('checked')))) ){
								$(this).prop('checked',false).closest('.column').removeClass('active');
							}else{
								clickCanBeDone = false;
							}
						}else{
							$(this).prop('checked',false).closest('.column').removeClass('active');
						}

					}else{
						clickCanBeDone = false;
					}
				}
				if($(this).closest('.column').hasClass('active')){
					$(this).prop('checked',true)
				}
			} else if(parentObj.growingBetsMode){
				var elem = $(this).closest('.column')
				if($(this).closest('.row').find('.column.active').length < parentObj.maxNumeros){
					$(elem).toggleClass('active');
				}else{
					if($(elem).hasClass("active")){
						$(elem).removeClass("active")
					}
				}
				if($(elem).hasClass("active")){
					$(this).prop('checked',true)
				}else{
					$(this).prop('checked',false)
				}
			} else {
				clickCanBeDone = false;
			}

/*
			if(parentObj.revertClickAction){
				if( $(this).prop('checked',true) ){
					$(this).closest('.column').removeClass('active')
				}else{
					$(this).closest('.column').addClass('active')
				}
				parentObj.revertClickAction=false
			}
*/

// 			console.log(this.getActiveColumn())

			if (!parentObj.isShuffleInProgress && clickCanBeDone) {

				var indexOfColumn = $(this).closest('[data-index]').attr("data-index");
				var numbersLength = $("[data-numberschoser]:not([data-extraschooser])").find(".row:eq("+indexOfColumn+")").find('input:checked').length
				$("[data-extraschooser]").find(".row.active").find('.column-block').each(function(k,v){
					if($(this).hasClass('active')){
						$(v).find('input').prop('checked',true)
					}else{
						$(v).find('input').prop('checked',false)
					}

				})
				if(!parentObj.hasExtrasOut){
					var extrasLength = $("[data-extraschooser]").find(".row:eq("+indexOfColumn+")").find('input:checked').length
				}else{
					var extrasLength = $("[data-extraschooser]").find(".row:eq(0)").find('input:checked').length
				}

				//******** iniciamos el objeto con el estado de cada columna al pulsar ******
				var colStatus = {
					col: parentObj.currentRow,
					extras:0,
					extrasRemaining:0,
					extrasName: false
				}
				if(parentObj.extrasName){
					colStatus.extrasName = parentObj.extrasName;
				}else{
					colStatus.extrasName = "";
				}
				/******************************************************************************/

				// Para el primer boleto
				if (!parentObj.growingBetsMode && $(this).closest('[data-index]').attr("data-index") == 0) {
					// Deshabilitar los demás boletos si en la primera se marcan más bets o extras, o si se permiten múltiples de 5
					//EVALUAMOS LA ACCION CUANDO SE MARCA UN BOTON, COMPROBAMOS LAS CONDICIONES QUE INDICAN EMPIEZA A SER MULTIPLE
						if (((!parentObj.hasExtrasOut && numbersLength > betsOrExtrasToChoseSN)
						|| ( parentObj.hasExtrasOut && (!parentObj.allowsMultipleWithLess && (numbersLength > parentObj.betsToChooseSN || extrasLength > parentObj.extrasToChooseSN))) || ( parentObj.hasExtrasOut && parentObj.allowsMultipleWithLess && (numbersLength > parentObj.betsToChooseSN || extrasLength > parentObj.extrasToChooseSN)) || (parentObj.allowsMultipleWithLess && $(this).closest('.row').find('input:checked').length == (betsOrExtrasToChoseSN - 1) ) || (parentObj.allowsMultipleWithLess && (numbersLength > parentObj.betsToChooseSN || numbersLength == parentObj.betsToChooseSN - 1) && extrasLength > 0 ))) {


							if (parentObj.allowsMultipleWithLess && numbersLength == parentObj.betsToChooseSN - 1){
								parentObj.isMultipleWithLessInProgress=true;
							}else{
								parentObj.isMultipleWithLessInProgress=false;
							}

							if (stateIsMultiple == true) {
								disableNonMultipleSummary(parentObj.numbersChoserSummaryElem, parentObj);
								if (typeof disableNonMultipleSymmaryCallback != "undefined") {
										disableNonMultipleSymmaryCallback(parentObj.checkColumnasCompletadas());
								}
							}

							if(numbersLength >= parentObj.minNumerosReduccion){ //Comprobamos si en las multiples, iniciamos la reducción
								if(!parentObj.isCondicionadaInProgress){
									parentObj.isReducidaInProgress=true;
								}
							}else{
								parentObj.isReducidaInProgress=false;
							}

							$('[data-boleto]').attr('data-isMultiple','true');
							parentObj.isMultipleInProgress=true;


							/*****************************************************************/
							var isIncomplete = false;
							var numNormal = $("[data-numberschoser]:not([data-extraschooser])").find(".row:eq(" + parentObj.currentRow + ")").find('input:checked').length;
							if (parentObj.hasExtrasOut) {
								if (parentObj.extrasUnique) {
									var numExtras = $("[data-extraschooser]").find("input:checked").length;
								}else{
									var numExtras = $("[data-numberschoser][data-extraschooser]").find(".row:eq(" + parentObj.currentRow + ")").find('input:checked').length;
								}
							}

							if(parentObj.allowsMultipleWithLess && parentObj.extrasUnique){
								if(numNormal == (parentObj.betsToChooseSN - 1) && parentObj.currentRow == 0 ){
								}else{
									if (numNormal < parentObj.betsToChooseSN) {
										isIncomplete = true
									}
								}
							}else if(parentObj.allowsMultipleWithLess && !parentObj.extrasUnique){
								if(numNormal == (parentObj.betsToChooseSN - 1) && parentObj.currentRow == 0){
								}else{
									if (numNormal != parentObj.betsToChooseSN) {
										isIncomplete = true
									}
								}
							}else if(!parentObj.allowsMultipleWithLess && parentObj.extrasUnique){
								if (numNormal != parentObj.betsToChooseSN) {
									isIncomplete = true
								}
							}


							/*****************************************************************/
							//Rellenamos el objeto COLSTATUS con el progreso de cada columna
							//Este objeto se pasará tanto en el evento de pulsación de número (onNumberPressedCallback), como en el (onAnyCompletedColumnExceptExtrasCallback)
							//**************************************************************
								colStatus["numbers"] = numNormal
								colStatus["numbersRemaining"] = parentObj.betsToChooseSN - numNormal;
								if(typeof numExtras != "undefined"){
									colStatus["extras"] = numExtras
									colStatus["extrasRemaining"] = parentObj.extrasToChooseSN - numExtras;
								}
							//**************************************************************


							if (parentObj.hasExtrasOut) {
// 								if (parentObj.extrasUnique) {
									if(numExtras < parentObj.extrasToChooseSN ){
										if(isIncomplete === false){
											parentObj.completeButIncompleteExtras = true
										}else{
											parentObj.completeButIncompleteExtras = false;
										}
									}else{
										if(isIncomplete === false){
											parentObj.completeButIncompleteExtras = false;
										}
									}
									if(parentObj.completeButIncompleteExtras){
										parentObj.markPager('incomplete', indexOfColumn)
										parentObj.boletoSnapshot[parentObj.getActiveColumn()].status = 2;
										if (typeof parentObj.onAnyCompletedColumnExceptExtrasCallback != "undefined") {
											parentObj.onAnyCompletedColumnExceptExtrasCallback(parentObj,colStatus);
										}
									}
// 								}
							}

							if (typeof clickedMultipleCallback != "undefined") {
								clickedMultipleCallback(parentObj,numbersLength, extrasLength,parentObj.maxBetsForDirectML);
							}


						}else{
							if(parentObj.allowsMultipleWithLess){
								parentObj.isMultipleInProgress = false;
								parentObj.isMultipleWithLessInProgress = false;
							}
						}

					//EVALUAMOS LA ACCION CUANDO SE DESMARCA UN BOTON, COMPROBAMOS LAS CONDICIONES QUE INDICAN QUE DEJA DE SER MULTIPLE
						if (!parentObj.growingBetsMode && (!parentObj.hasExtrasOut && numbersLength <= betsOrExtrasToChoseSN)
						 || (parentObj.hasExtrasOut && (!parentObj.allowsMultipleWithLess && numbersLength <= parentObj.betsToChooseSN && extrasLength <= parentObj.extrasToChooseSN) /* && stateIsMultiple == "true" */)
						 || (parentObj.hasExtrasOut && ( parentObj.allowsMultipleWithLess && (numbersLength <= parentObj.betsToChooseSN && extrasLength != parentObj.extrasToChooseSN - 1) )/*  && stateIsMultiple == "true" */)){
								var isIncomplete = false;
								var numNormal = $("[data-numberschoser]:not([data-extraschooser])").find(".row:eq(" + parentObj.currentRow + ")").find('input:checked').length;
								if (parentObj.hasExtrasOut) {
									if (parentObj.extrasUnique) {
										var numExtras = $("[data-extraschooser]").find("input:checked").length;
									}else{
										var numExtras = $("[data-numberschoser][data-extraschooser]").find(".row:eq(" + parentObj.currentRow + ")").find('input:checked').length;
									}
								}
								var isnotMultiple = false

								if(parentObj.hasExtrasOut && parentObj.allowsMultipleWithLess){
									if(extrasLength <= parentObj.extrasToChooseSN){
										if(parentObj.hasExtrasOut && parentObj.allowsMultipleWithLess){
											if(numbersLength <= parentObj.betsToChooseSN){
												if(numbersLength != parentObj.betsToChooseSN - 1 ){
													isnotMultiple = true
												}
											}
										}
									}else{
										isnotMultiple = true
									}
								}else if ((!parentObj.hasExtrasOut && !parentObj.allowsMultipleWithLess) || (parentObj.hasExtrasOut && !parentObj.allowsMultipleWithLess)){
									if(!parentObj.hasExtrasOut){
										if(numbersLength <= parentObj.betsToChooseSN){
											isnotMultiple = true
										}
									}else if(parentObj.hasExtrasOut && !parentObj.allowsMultipleWithLess){
										if(numbersLength <= parentObj.betsToChooseSN && extrasLength == parentObj.extrasToChooseSN){
											isnotMultiple = true
										}

									}
								}else if(!parentObj.hasExtrasOut && parentObj.allowsMultipleWithLess){
									if(numbersLength <= parentObj.betsToChooseSN ){
										if(numbersLength != parentObj.betsToChooseSN - 1){
											isnotMultiple = true
										}
									}
								}





								if (isnotMultiple && parentObj.isMultipleInProgress){
									enableNonMultipleSummary(parentObj.numbersChoserSummaryElem, parentObj);
									if (typeof enableNonMultipleSummaryCallback != "undefined") {
										enableNonMultipleSummaryCallback();
									}
									parentObj.checkColumnasCompletadas();//  console.log("enableNonMultipleSummary primer boleto")
									if(!parentObj.isSetToMultiple){
										$('[data-boleto]').removeAttr('data-isMultiple');
									}else{
										if(typeof $('[data-boleto]').attr('data-isMultiple') != "undefined"){
											$('[data-boleto]').attr('data-isMultiple',false);
										}
									}
									parentObj.isMultipleInProgress=false;
									parentObj.isReducidaInProgress=false;
									parentObj.isMultipleWithLessInProgress=false;
								}



							/*****************************************************************/

							//Rellenamos el objeto COLSTATUS con el progreso de cada columna
							//Este objeto se pasará tanto en el evento de pulsación de número (onNumberPressedCallback), como en el (onAnyCompletedColumnExceptExtrasCallback)
							//**************************************************************

							colStatus["numbers"] = numNormal
							colStatus["numbersRemaining"] = parentObj.betsToChooseSN - numNormal;
							if(typeof numExtras != "undefined"){
								colStatus["extras"] = numExtras
								colStatus["extrasRemaining"] = parentObj.extrasToChooseSN - numExtras;
							}
							//**************************************************************
							//Evaluamos si está completado con sus extras y todo
								if(parentObj.allowsMultipleWithLess && parentObj.extrasUnique){
									if(numNormal == (parentObj.betsToChooseSN - 1) && parentObj.currentRow == 0 ){
									}else{
										if (numNormal < parentObj.betsToChooseSN) {
											isIncomplete = true
										}
									}
								}else if(parentObj.allowsMultipleWithLess && !parentObj.extrasUnique){
									if(numNormal == (parentObj.betsToChooseSN - 1) && parentObj.currentRow == 0){
									}else{
										if (numNormal != parentObj.betsToChooseSN) {
											isIncomplete = true
										}
									}
								}else if(!parentObj.allowsMultipleWithLess && parentObj.extrasUnique){
									if (numNormal != parentObj.betsToChooseSN) {
										isIncomplete = true
									}
								}else if(!parentObj.allowsMultipleWithLess && !parentObj.extrasUnique && parentObj.hasExtrasOut){
									if (numNormal != parentObj.betsToChooseSN) {
										isIncomplete = true
									}
								}
								if (parentObj.hasExtrasOut) {
									if (!parentObj.extrasUnique) {
										if(numExtras < parentObj.extrasToChooseSN ){
											if(isIncomplete === false){
												parentObj.completeButIncompleteExtras = true
											}else{
												parentObj.completeButIncompleteExtras = false;
											}
										}else{
											if(isIncomplete === false){
												parentObj.completeButIncompleteExtras = false;
											}
										}
										if(parentObj.completeButIncompleteExtras){
											parentObj.markPager('incomplete', indexOfColumn)
											parentObj.boletoSnapshot[parentObj.getActiveColumn()].status = 2;
											if (typeof parentObj.onAnyCompletedColumnExceptExtrasCallback != "undefined") {
												parentObj.onAnyCompletedColumnExceptExtrasCallback(parentObj,colStatus);
											}
										}
									}
								}
								//**************************************************************


						}
				}
				// Para todos los boletos
				// Marcar el boleto como incompleto si no tiene el número de bets o extras en casos normales. Aceptamos como buenos los multiples de 5, pero NO aquellos que ademas tengan extras únicos (Primitiva), que los evaluamos.
				var numNormal = $("[data-numberschoser]:not([data-extraschooser])").find(".row:eq(" + parentObj.currentRow + ")").find('input:checked').length;
				if (parentObj.hasExtrasOut) {
					if (!parentObj.extrasUnique) {
						var numExtras = $("[data-extraschooser]").find(".row:eq(" + parentObj.currentRow + ")").find("input:checked").length
					} else {
						var numExtras = $("[data-extraschooser]").find("input:checked").length;
					}
				}



				//Rellenamos el objeto COLSTATUS con el progreso de cada columna
				//Este objeto se pasará tanto en el evento de pulsación de número (onNumberPressedCallback), como en el (onAnyCompletedColumnExceptExtrasCallback)
				//**************************************************************

				colStatus["numbers"] = numNormal
				colStatus["numbersRemaining"] = parentObj.betsToChooseSN - numNormal;
				if(typeof numExtras != "undefined"){
					colStatus["extras"] = numExtras
					colStatus["extrasRemaining"] = parentObj.extrasToChooseSN - numExtras;
				}
				parentObj.onNumberPressedCallback(colStatus,parentObj);

				if(!parentObj.growingBetsMode){

					//**************************************************************
					if ((numNormal < (parentObj.betsToChooseSN ) ) || (!parentObj.extrasUnique && (numNormal < (parentObj.betsToChooseSN) || numNormal == (parentObj.betsToChooseSN)) ) || (!parentObj.extrasUnique && ( (numNormal == (parentObj.betsToChooseSN - 1) && numExtras == parentObj.extrasToChooseSN) || (numNormal == parentObj.betsToChooseSN && numExtras == (parentObj.extrasToChooseSN - 1)) ) ) || (parentObj.extrasUnique && ((numNormal == (parentObj.betsToChooseSN - 1) && numExtras == parentObj.extrasToChooseSN) || (numExtras == 0 && numNormal == parentObj.betsToChooseSN) || (numExtras == 0 && numNormal == parentObj.betsToChooseSN - 1) ))) {
	 					var isIncomplete = false
						if(parentObj.allowsMultipleWithLess && parentObj.extrasUnique){
							if(numExtras < parentObj.extrasToChooseSN ){
								isIncomplete = true
								var extrasIncomplete = true
							}else{
								var extrasIncomplete = false
							}

							if(numNormal == (parentObj.betsToChooseSN - 1) && parentObj.currentRow == 0 ){
								if(extrasIncomplete){
									parentObj.completeButIncompleteExtras = true
								}else{
									parentObj.completeButIncompleteExtras = false
								}
							}else{
								if (numNormal != parentObj.betsToChooseSN) {
									isIncomplete = true
								}
								if(extrasIncomplete && !isIncomplete){
									parentObj.completeButIncompleteExtras = true
								}else{
									parentObj.completeButIncompleteExtras = false
								}

							}
						}else if(parentObj.allowsMultipleWithLess && !parentObj.extrasUnique){
							if(numNormal == (parentObj.betsToChooseSN - 1) && parentObj.currentRow == 0){

							}else{
								if (numNormal != parentObj.betsToChooseSN) {
									isIncomplete = true
								}
							}
						}else if(!parentObj.allowsMultipleWithLess && parentObj.extrasUnique){
							if (numNormal != parentObj.betsToChooseSN) {
								isIncomplete = true
							}
							if(numExtras < parentObj.extrasToChooseSN && !isIncomplete){
								parentObj.completeButIncompleteExtras = true;
							}else{
								parentObj.completeButIncompleteExtras = false
							}

						}else if(!parentObj.allowsMultipleWithLess && !parentObj.extrasUnique && parentObj.hasExtrasOut){
							if(numNormal != parentObj.betsToChooseSN){
								isIncomplete = true;
							}
							if(numExtras < parentObj.extrasToChooseSN && !isIncomplete){
								parentObj.completeButIncompleteExtras = true;
							}else{
								parentObj.completeButIncompleteExtras = false;
							}
						}

						if(!parentObj.growingBetsMode){
							if( isIncomplete || parentObj.completeButIncompleteExtras/*  || !parentObj.allowsMultipleWithLess */){
								parentObj.markPager('incomplete', indexOfColumn)
								parentObj.boletoSnapshot[parentObj.getActiveColumn()].status = 2;
								if (typeof anyColumnIncompleteCallback != "undefined") {
									anyColumnIncompleteCallback(Math.abs(parentObj.checkColumnasCompletadas()));
								}

							}
							if( !isIncomplete && parentObj.allowsMultipleWithLess && !parentObj.completeButIncompleteExtras){
								parentObj.onColumnaCompletadaPteSeleccionMultiple(parentObj)
							}

							if(parentObj.completeButIncompleteExtras){
								parentObj.markPager('incomplete', indexOfColumn)
								parentObj.boletoSnapshot[parentObj.getActiveColumn()].status = 2;

								if (typeof parentObj.onAnyCompletedColumnExceptExtrasCallback != "undefined") {
									parentObj.onAnyCompletedColumnExceptExtrasCallback(parentObj,colStatus);
								}
							}
						}
					}
				}else{
					var isIncomplete = false
					if(numNormal < parentObj.minNumeros){
						isIncomplete = true
					}
					if(isIncomplete){
						parentObj.markPager('incomplete', indexOfColumn)
						parentObj.boletoSnapshot[parentObj.getActiveColumn()].status = 2;

						if (typeof anyColumnIncompleteCallback != "undefined") {
							anyColumnIncompleteCallback(Math.abs(parentObj.checkColumnasCompletadas()));
						}
					}
				}


				// Cuando tiene cero casillas marcadas
				if (	((!parentObj.hasExtrasOut || parentObj.extrasUnique) && numNormal == 0) ||
						( 	parentObj.hasExtrasOut && ($("[data-numberschoser]:not([data-extraschooser]) [data-index='" + indexOfColumn + "']").find('.column.active').length == 0 &&
							$("[data-extraschooser] [data-index='" + indexOfColumn + "']").find('.column.active').length == 0))
						) {

					parentObj.checkColumnasCompletadas();
					if (typeof anyColumnEmptyCallback != "undefined") {
/*
						if(parentObj.rawApuesta.length>0){
							parentObj.rawApuesta = new Array();
						}
*/
						anyColumnEmptyCallback(parentObj);
					}
// 					console.log("cero casillas marcadas (????quitar?")
					parentObj.markPager('empty', indexOfColumn)
					parentObj.boletoSnapshot[parentObj.getActiveColumn()].status = 0;

				}

				// Cuando se marca la primera casilla
				if ($(this).closest('.column').hasClass('active') && ( ( (!parentObj.hasExtrasOut || parentObj.extrasUnique) && numNormal == 1) || (parentObj.hasExtrasOut && ((numNormal == 1 && numExtras == 0) || (numExtras == 1 && numNormal == 0)) ) )) {
					if (typeof oneNumberSelectedCallback != "undefined" && typeof anyColumnIncompleteCallback != "undefined") {
/*
						if (typeof myPurchaseOptions !== "undefined") {
							myPurchaseOptions.numeroApuestas += 1;
						}
*/
						oneNumberSelectedCallback();
						anyColumnIncompleteCallback(Math.abs(parentObj.checkColumnasCompletadas()));
					}
				}

				// Cuando tiene el número exacto de extras y bets, marcar como hecho, y habilitar los demás boletos
				if (	(((!parentObj.hasExtrasOut) && numNormal == parentObj.betsToChooseSN) ||
						( 	parentObj.hasExtrasOut && ($("[data-numberschoser]:not([data-extraschooser]) [data-index='" + indexOfColumn + "']").find('.column.active').length >= parentObj.betsToChooseSN &&
							$("[data-extraschooser] [data-index='" + indexOfColumn + "']").find('.column.active').length >= parentObj.extrasToChooseSN))) ||
						(parentObj.hasExtrasOut && parentObj.extrasUnique && $("[data-numberschoser]:not([data-extraschooser]) [data-index='" + indexOfColumn + "']").find('.column.active').length >= parentObj.betsToChooseSN && $("[data-extraschooser] [data-index='0']").find('.column.active').length == 1) ||
						!parentObj.hasExtras &&  numNormal >= parentObj.betsToChooseSN
						) {
					parentObj.markPager('done', indexOfColumn)
					parentObj.boletoSnapshot[parentObj.getActiveColumn()].status = 1;

					if(parentObj.progressiveColumns){ //Si se completa la columna, se habilita la siguiente
						parentObj.unblockColumn(parentObj.getActiveColumn()+1);
					}
					parentObj.checkColumnasCompletadas();

					if (typeof anyColumnDoneCallback != "undefined") {
						anyColumnDoneCallback(parentObj);
						if ($(this).closest('[data-index]').attr("data-index") == 0 && typeof firstColumnDoneCallback != "undefined") {

							if (!parentObj.extrasUnique || $(this).closest("[data-extraschooser]").length == 0 || (parentObj.hasExtrasOut && parentObj.extrasUnique && $("[data-numberschoser]:not([data-extraschooser]) [data-index='" + indexOfColumn + "']").find('.column.active').length >= parentObj.betsToChooseSN && $("[data-extraschooser] [data-index='0']").find('.column.active').length == 1)){
								firstColumnDoneCallback(parentObj);
							}
						}
					}
// 					console.log(" número exacto de extras y bets")
					//Comprobamos si las columnas completadas son igual al número de columnas mínimo para sellar
				}



				$("#numbersChoserSummary").find("tr:not('.disabled')").each(function() {
					if (!$(this).find("td:eq(0) span").hasClass("done") && allOk) {
						allOk = false;
					}
				});

				// Cuando se desmarcan todas,
				if ((	(!parentObj.hasExtrasOut && $(this).closest('.row').find('.column.active').length == 0) ||
						(parentObj.hasExtrasOut && ($("[data-numberschoser]:not([data-extraschooser])").find(".row.active").find('.column.active').length == 0 &&
						$("[data-extraschooser]").find(".row.active").find('.column.active').length == 0)))) {
				}


				//Actualizamos contador páginas
				if (!parentObj.hasExtrasOut){ //No contamos como columna activa si es un extra único fuera de cada columna
					parentObj.currentBet = parentObj.currentRow;/* $(this).closest('[data-columna]').index(); */
				}else{
					var currentBetElem 	= $(this).closest('[data-columna]');
					if ( $(currentBetElem).attr('data-extrasChooser') != "undefined"){
						parentObj.currentBet = parentObj.currentRow;/* $(currentBetElem).index(); */
					}
				}
				updateNumbersPager()
				//updatePremio();


				if(parentObj.revertClickAction){
					parentObj.revertClickAction=false;
// 					if(!parentObj.hasExtrasOut || (parentObj.hasExtrasOut && $(parentObj.lastPressedElement).closest('[data-extraschooser]').length == 0) ){
						if(!$(parentObj.lastPressedElement).prop('checked')){
							$(parentObj.lastPressedElement).prop('checked',true)
							$(parentObj.lastPressedElement).closest('.column').removeClass('active')
						}else{
							$(parentObj.lastPressedElement).prop('checked',false)
							$(parentObj.lastPressedElement).closest('.column').addClass('active')
						}
						$(parentObj.lastPressedElement).trigger('change')
 						$(parentObj.lastPressedElement).closest('label').trigger('click')

/*
					}else{
						if(parentObj.hasExtrasOut && $(parentObj.lastPressedElement).closest('[data-extraschooser]').length > 0){
								$(parentObj.lastPressedElement).closest('label').trigger('click')
						}
					}
*/
				}

			}

		// Para Quiniela
		} else if (parentObj.isQuiniela) {
			var isIncomplete = false;

			parentObj.lastPressedElement = $(this);
			var thisRowIndex = $(this).closest('td').index();
			if(typeof $(this).closest('td').attr('data-columna-extra') == "undefined"){
				parentObj.currentRow =  thisRowIndex - parentObj.firstPlayableCol/* 4 */;
			}else{
				parentObj.currentRow =  0; //Si se está activando la columna extra, significa que estamos en la columna 0 de múltiples
			}

			//*********************************************************************************************************
			// Primer boleto (Está en cuarto lugar).
			//*********************************************************************************************************
			if ($(this).closest('td').index() == parentObj.firstPlayableCol) {

				var howMany = $(this).closest('td').find('label.active').length
				if (!$(this).closest("label").hasClass("active") && (howMany < 1 || (howMany >= 1 && parentObj.allowMultiple))) {
					$(this).closest("label").addClass("active");
				}else if($(this).closest("label").hasClass("active")){
					$(this).closest("label").removeClass("active");
				}
				/* $(this).closest("label").toggleClass('active'); */

				if ($(this).closest("label").hasClass('active')) { // Si lo que se ha hecho es marcar
					howMany = $(this).closest('td').find('label.active').length

					if (howMany <= 1) {
						if($(this).closest('tbody').find('tr td[data-quinielaColumn]:nth-child(5) label.active').length<=1){
							if (typeof oneNumberSelectedCallback != "undefined" && typeof anyColumnIncompleteCallback != "undefined") {
								oneNumberSelectedCallback();
/*
								console.log("wa")
								anyColumnIncompleteCallback(Math.abs(parentObj.checkColumnasCompletadas()));
*/
							}
						}
					} else if(parentObj.allowMultiple){
						if (/* $('[data-numbersChoser]').attr('data-isMultiple') != "true" &&  */typeof disableNonMultipleSymmaryCallback !== "undefined") {
							disableNonMultipleSymmaryCallback(parentObj.checkColumnasCompletadas());
						}
						$('[data-numbersChoser]').attr('data-isMultiple', 'true');
						$('[data-boleto]').attr('data-isMultiple', 'true');
						disableNonMultipleSummary(parentObj.numbersChoserSummaryElem, parentObj);
						parentObj.isMultipleInProgress=true;
						parentObj.multipleChecked++;
					}
				} else { // Si lo que se ha hecho es desmarcar
					var isMultiple = false;
					$("[data-quinielacolumn]").each(function() {
						if($(this).find("label.active").length > 1) {
							isMultiple = true;
							parentObj.multipleChecked--;
							return false;
						}
					});
					if (!isMultiple) {
						parentObj.isMultipleInProgress=false;
						parentObj.multipleChecked=0;
					}
/*
					if ($('[data-numbersChoser]').attr('data-isMultiple') != isMultiple.toString() ){
						if( typeof enableNonMultipleSummaryCallback !== "undefined"){
							enableNonMultipleSummaryCallback();
						}
					}
*/
					$('[data-numbersChoser]').attr('data-isMultiple', isMultiple);
					$('[data-boleto]').attr('data-isMultiple', isMultiple);
					parentObj.checkColumnasCompletadas();

					if (!parentObj.isMultipleInProgress ){
						if( typeof enableNonMultipleSummaryCallback !== "undefined"){
							enableNonMultipleSummaryCallback(parentObj.getColumnasCompletadasCache().correct);
						}
					}

					if (!isMultiple) { // Múltiple significa con varios boletos.
						enableNonMultipleSummary(parentObj.numbersChoserSummaryElem, parentObj);
					}
					$("[data-numberschoser] tr").find("td[data-quinielacolumn]:eq(0) label.active").each(function() {
						var i = $(this).closest("tr").index() + 1;
						var j = $(this).attr("data-value");
					});
	/*
				var length = $("[data-numberschoser] tr").find("td[data-quinielacolumn='0']").find("[data-value].active").length;
					allCorrect = true;
					if (length != 16 && length != 0) {
						allCorrect = false;
					}
					if (!allCorrect) {
						anyColumnIncompleteCallback(Math.abs(parentObj.checkColumnasCompletadas()));
						parentObj.markPager('incomplete', parentObj.currentRow)
						parentObj.boletoSnapshot[parentObj.getActiveColumn()].status = 1;

					}
*/
				}
				//******** iniciamos el objeto con el estado de cada columna al pulsar ******
				var colStatus = {
					col: parentObj.currentRow,
					numbers:0,
					numbersRemaining:0,
					extras:0,
					extrasRemaining:0, //Columna de condicionadas o reducidas o elige8
					p15:0,
					p15Remaining:0
				}
				if(parentObj.extrasName){
					colStatus.extrasName = parentObj.extrasName;
				}else{
					colStatus.extrasName = "";
				}

				if (typeof firstColumnDoneCallback !== "undefined" && !parentObj.isShuffleInProgress) {
					var allCorrect = true;
					var noneCorrect = true;
					var atLeastOneMultiple = false;
					var normalNumbers = 0;
					var extraNumbers = 0;
					var plenoNumbers = 0;

					$("[data-numberschoser] tr").not('thead tr').find("td[data-quinielacolumn]:eq(0)").each(function() {
						var length = $(this).find("[data-value].active").length;
						if ($(this).closest("tr").find("[data-columna-extra] label").hasClass('active')) { //Para reducciones y condicionadas
							$(this).attr("data-mult-num", length);
							$(this).attr("data-mult-num-bis", length);
							extraNumbers++;
						} else {
							$(this).attr("data-mult-num", length);
							$(this).attr("data-mult-num-bis", 1);
						}

						if(typeof $(this).attr('data-isplenoal15') == "undefined"){
							//Es un número normal
							if (length >= 1){
								normalNumbers++;
							}
						}else{
							if(length >= 1){
								plenoNumbers++;
							}
						}

						if (length == 0) {
							allCorrect = false;
						} else {
							noneCorrect = false;
						}
						if (length > 1) {
							atLeastOneMultiple = true;
						}

					});

					if(plenoNumbers < 2 || normalNumbers < 14 || (parentObj.hasExtrasOut &&  extraNumbers < parentObj.extrasToChooseSN) || plenoNumbers < 2){
						allCorrect = false;
					}

					colStatus["numbers"] = normalNumbers;
					colStatus["numbersRemaining"] = 14-normalNumbers;
					colStatus["extras"] = extraNumbers;
					colStatus["extrasRemaining"] = 0;
					if(parentObj.hasExtrasOut){ //Elige8 activo
						colStatus["extrasRemaining"] = parentObj.extrasToChooseSN - extraNumbers;
					}
					colStatus["p15"] = plenoNumbers;
					colStatus["p15Remaining"] = 2 - plenoNumbers;

					if (allCorrect) {
						parentObj.checkColumnasCompletadas();
						parentObj.onNumberPressedCallback(colStatus,parentObj);
						console.log(estado)
						firstColumnDoneCallback(parentObj);
						if(typeof anyColumnDoneCallback !== "undefined"){
							anyColumnDoneCallback(parentObj,colStatus);
						}


						parentObj.markPager('done', parentObj.currentRow)
						parentObj.boletoSnapshot[parentObj.getActiveColumn()].status = 1;
						if(parentObj.progressiveColumns){
							parentObj.unblockColumn(parentObj.getActiveColumn()+1);
						}

					} else {
						parentObj.onNumberPressedCallback(colStatus,parentObj);

						if (noneCorrect) {
							parentObj.markPager('empty', parentObj.currentRow)
							parentObj.boletoSnapshot[parentObj.getActiveColumn()].status = 0;
						} else {
							parentObj.markPager('incomplete', parentObj.currentRow)
							anyColumnIncompleteCallback(Math.abs(parentObj.checkColumnasCompletadas()),colStatus);
							parentObj.boletoSnapshot[parentObj.getActiveColumn()].status = 2;
						}


					}
					if (atLeastOneMultiple && typeof clickedMultipleCallback !== "undefined") {
						clickedMultipleCallback(parentObj);
					}
				}

			} else { // Demás boletos, que no son el primero.
				var colStatus = {
					numbers:0,
					numbersRemaining:0,
					extras:0,
					extrasRemaining:0, //Columna de condicionadas o reducidas
					p15:0,
					p15Remaining:0
				}
				var normalNumbers = 0; //Guardamos los de la columna 0 para tener algunos si se pulsa en los extras


				/*************************************************************************************/
				/* Recalculamos el estado del resto de valores comunes (pleno, extras (elige8), etc) */
				/*************************************************************************************/
				$("[data-numberschoser] tr").not('thead tr').find("td[data-quinielacolumn]:eq(0)").each(function() {
					var length = $(this).find("[data-value].active").length;

					if(typeof $(this).attr('data-isplenoal15') != "undefined"){
						if(length >= 1){
							colStatus["p15"]++;
						}
					}else{
						if(length >= 1){
							normalNumbers++;
						}
					}
				})
				colStatus["p15Remaining"] = 2 - colStatus["p15"];
				/******************************************************************************************************************************************/



				if ($('[data-numbersChoser]').attr('data-isMultiple') === 'false' || typeof $('[data-numbersChoser]').attr('data-isMultiple') == "undefined" || typeof $(this).closest("td").attr("data-columna-extra") !== "undefined" ) { //No es múltiple, así que seguimos marcando elementos*/

					if(typeof $(this).closest("td").attr("data-columna-extra") == "undefined" ){
						colStatus["col"] = parentObj.getActiveColumn();

						if ($(this).closest('td').find('label.active').length == 0) {
							$(this).closest("label").toggleClass('active')
						} else if ($(this).closest("label").hasClass("active")) {
							$(this).closest("label").toggleClass('active')
						} else {
							$(this).closest('td').find('label.active').toggleClass('active');
							$(this).closest("label").toggleClass('active');
						}

					}else{
						colStatus["col"] = 0;
						var activos = $('[data-quinielacolumn][data-columna-extra] label.active');
						var elem = $(this).closest("label");
						if( $(elem).hasClass("active")){
							$(elem).toggleClass('active');
						}else{
							//Sólo permitimos la activación si es condicionada o reducida
							//o si se ha activado la opcion de elige8 (hasExtrasOut)
							if(parentObj.hasExtrasOut && (!parentObj.isReducidaInProgress && !parentObj.isCondicionadaInProgress && !parentObj.isSetToCondicionada && !parentObj.isSetToReducida) ){
								if(activos.length < parentObj.extrasToChooseSN){
									$(elem).toggleClass('active')
								}
							}else if(!parentObj.hasExtrasOut && (parentObj.isReducidaInProgress || parentObj.isCondicionadaInProgress || parentObj.isSetToCondicionada || parentObj.isSetToReducida)){
								$(elem).toggleClass('active');
							}else if(parentObj.hasExtrasOut && (parentObj.isReducidaInProgress || parentObj.isCondicionadaInProgress || parentObj.isSetToCondicionada || parentObj.isSetToReducida)){
								$(elem).toggleClass('active')
							}
						}
						var activos = $('[data-quinielacolumn][data-columna-extra] label.active');
						colStatus["extras"] = activos.length;
						colStatus["numbers"] = normalNumbers;
						colStatus["numbersRemaining"] = 14- normalNumbers;
						if(parentObj.hasExtrasOut && (!parentObj.isReducidaInProgress && !parentObj.isCondicionadaInProgress && !parentObj.isSetToCondicionada && !parentObj.isSetToReducida)){ //Elige8 activo
							colStatus["extrasRemaining"] = parentObj.extrasToChooseSN - activos.length;
						}else{
							colStatus["extrasRemaining"] = false;
						}

						delete parentObj.rawApuesta.elige8
					}
				}


				if (!parentObj.isShuffleInProgress && ( typeof $(this).closest("td").attr("data-columna-extra") === "undefined" || (typeof $(this).closest("td").attr("data-columna-extra") !== "undefined" && !parentObj.isReducidaInProgress && !parentObj.isCondicionadaInProgress ) )) {
					var index = $(this).closest('td').index() - parentObj.firstPlayableCol;
					var elige8Length = $("[data-numberschoser] tr").find("td[data-columna-extra][data-quinielacolumn]").find("[data-value].active").length;
					if(typeof $(this).closest("td").attr("data-columna-extra") !== "undefined" && !parentObj.isReducidaInProgress && !parentObj.isCondicionadaInProgress && !parentObj.isSetToCondicionada && !parentObj.isSetToReducida){
						var elige8correct = true;

						//Miramos si hay elige8 en progreso
						if(parentObj.hasExtrasOut){

							if(elige8Length > 0 && elige8Length != parentObj.extrasToChooseSN){
								elige8correct = false;
							}
							if(elige8Length == 0){
								elige8correct = false;
							}
							allCorrect = elige8correct;
							colStatus["extrasRemaining"] = parentObj.extrasToChooseSN - elige8Length;
							colStatus["extras"] = elige8Length;
						}

					}else{
						var length = $("[data-numberschoser] tr").find("td[data-quinielacolumn]:not([data-columna-extra]):eq(" + index + ")").find("[data-value].active").length;
						allCorrect = true;
						colStatus["numbers"] = length;
						if (length != 14 && length != 0) {
							allCorrect = false;
							colStatus["numbersRemaining"] = 14 - length;
						}
						if(parentObj.hasExtrasOut){
							if(elige8Length == 0){
								elige8correct=false;
								allCorrect = false;
							}
							colStatus["extrasRemaining"] = parentObj.extrasToChooseSN - elige8Length;
							colStatus["extras"] = elige8Length;

						}
					}

					if (allCorrect) {
							var estado = parentObj.checkColumnasCompletadas(true);
							parentObj.onNumberPressedCallback(colStatus,parentObj);

							if(typeof anyColumnDoneCallback !== "undefined"){
								anyColumnDoneCallback(parentObj,colStatus);
							}

						if (length == 0) {
							parentObj.markPager('empty', parentObj.currentRow)
							parentObj.boletoSnapshot[parentObj.getActiveColumn()].status = 0;

						} else {
							parentObj.markPager('done', parentObj.currentRow)
							parentObj.boletoSnapshot[parentObj.getActiveColumn()].status = 1;
							if(parentObj.progressiveColumns && estado.incompleteExtras == 0){
								parentObj.unblockColumn(parentObj.getActiveColumn()+1);
							}

						}
					} else if (!$(this).closest("label").hasClass('active') && length == 13 || length==1 || !elige8correct) { // Si lo que se ha hecho es desmarcar y falta uno para que esté completo, o hay elige8 que no este completo
						parentObj.onNumberPressedCallback(colStatus,parentObj);

						if (typeof anyColumnIncompleteCallback != "undefined") {
							anyColumnIncompleteCallback(Math.abs(parentObj.checkColumnasCompletadas()),colStatus);
						}
						parentObj.markPager('incomplete', parentObj.currentRow)
						parentObj.boletoSnapshot[parentObj.getActiveColumn()].status = 2;

					}

				}

				if (typeof $(this).closest("td").attr("data-columna-extra") !== "undefined" && parentObj.isMultipleInProgress) {
					parentObj.onNumberPressedCallback(colStatus,parentObj);

					if(parentObj.hasExtrasOut && parentObj.isSetToReducida || !parentObj.hasExtrasOut){
						if ($(this).closest('label').hasClass('active')) {
							var length = $(this).closest("tr").find("td:eq("+parentObj.firstPlayableCol+") [data-value].active").length;
							$(this).closest("tr").find("td:eq("+parentObj.firstPlayableCol+")").attr("data-mult-num-bis", length);
							parentObj.isReducidaInProgress=true;
						} else {
							$(this).closest("tr").find("td:eq("+parentObj.firstPlayableCol+")").attr("data-mult-num-bis", 1);
							if($("[data-numberschoser] [data-columna-extra] [data-value].active").length==0){
								parentObj.isReducidaInProgress=false;
							}
						}
						clickedMultipleCallback(parentObj);
					}
					if(!parentObj.isSetToReducida && !parentObj.isSetToCondicionada && !parentObj.isReducidaInProgress && !parentObj.isCondicionadaInProgress){
						clickedMultipleCallback(parentObj);
					}
				}

			}

		} else if (parentObj.isQuinigol) {

			$(this).closest("label").toggleClass('active');
			var row = $("th[data-quinielacolumn].active").index() - 2;
			if ($(this).closest("label").hasClass('active')) { // Si lo que se ha hecho es marcar
				if (row == 1) {
					if ($(this).closest('td').find('label.active').length > 1) {
						disableNonMultipleSummary(parentObj.numbersChoserSummaryElem, parentObj);
						$('[data-numbersChoser]').attr('data-isMultiple', "true");
					}
				} else {
					if ($(this).closest('td').find('label.active').length == 2) {
						$(this).closest('td').find('label.active').removeClass("active");
						$(this).closest("label").toggleClass('active');
					}
				}
			} else { // Si lo que se ha hecho es desmarcar
				if (row == 1) {
					var isMultiple = false;
					$("[data-quinielacolumn]").each(function() {
						if($(this).find("label.active").length > 1) {
							isMultiple = true;
							return false;
						}
					});
					$('[data-numbersChoser]').attr('data-isMultiple', isMultiple);
					if (!isMultiple) {
						enableNonMultipleSummary(parentObj.numbersChoserSummaryElem, parentObj);
						$("[data-numberschoser] tr").find("td[data-quinielacolumn]:eq(0) label.active").each(function() {
							var i = $(this).closest("tr").index() + 1;
							var j = $(this).attr("data-value");
						});
					} else {
					}
				}
			}


		}

		//Actualizamos contador páginas
		var currentBetElem 	= $(this).closest('[data-quinielacolumn]');
		if ( typeof $(currentBetElem).attr('data-isplenoal15') == "undefined"){
			parentObj.currentBet = parentObj.currentRow;/* $(currentBetElem).index(); */
		}
		updateNumbersPager()
		if(parentObj.revertClickAction){
			parentObj.revertClickAction=false;
// 			if(!parentObj.hasExtrasOut || (parentObj.hasExtrasOut && $(parentObj.lastPressedElement).closest('[data-extraschooser]').length == 0) ){
				if(!$(parentObj.lastPressedElement).prop('checked')){
					$(parentObj.lastPressedElement).prop('checked',true)
					$(parentObj.lastPressedElement).closest('.column').removeClass('active')
				}else{
					$(parentObj.lastPressedElement).prop('checked',false)
					$(parentObj.lastPressedElement).closest('.column').addClass('active')
				}
				$(parentObj.lastPressedElement).trigger('change')
 				$(parentObj.lastPressedElement).closest('label').trigger('click')
/*

			}else{
				if(parentObj.hasExtrasOut && $(parentObj.lastPressedElement).closest('[data-extraschooser]').length > 0){
						$(parentObj.lastPressedElement).closest('label').trigger('click')
				}
			}
*/
		}
	});


	// ************ PAGINACIÓN *************
	if (!this.isQuiniela && !this.isQuinigol) {
		var selector = ".row";
		var juego = "numbers";
	} else {
		var selector = "[data-quinielacolumn]:not([data-columna-extra]):not([data-isPlenoAl15]):not([data-quinielacolumn=''])";
		var juego = "quiniela";
	}

	$(".numbersChoserPages li").off('click').click(function() {
		if((parentObj.ignorePagerClicksOnDesktop==true && !Foundation.MediaQuery.atLeast('large')) || parentObj.ignorePagerClicksOnDesktop==false) { //Ejecuta solo en medium-small

			$(".numbersChoserPages li").removeClass("active").removeClass("bounceIn").removeClass("animated").addClass("disabled");
			$(this).addClass("active").removeClass("disabled").addClass("bounceIn").addClass("animated");
		}
		var indexOfPage = $(this).index()

		if ($("[data-extrasChooser] .row").length == 1) {
			var currElem=$('[data-numbersChoser]:not([data-extrasChooser]) ' + selector + '.active');
		} else {
			var currElem=$('[data-numbersChoser] ' + selector + '.active');
		}
		if (!$(this).hasClass("disabled")) {
			// Obtenemos el elemento actual en base al selector elegido y a su posicion en el DOM con respecto a los otros no activos
			var currentSelectorIndex=0;
			var i=0;

			if ($('[data-numberschoser] [data-quinielacolumn]').length == 0) {
				var indexFind='[data-numberschoser]:eq(0)';
			} else {
				var indexFind='[data-numberschoser] tbody tr:eq(0)';
			}
			$(indexFind).find(selector).each(function() {
				if ($(this).hasClass('active')){
					currentSelectorIndex=i;
					return false;
				} else {
					i++;
				}
			});
			// Quiniela
			if ($('[data-numberschoser] [data-quinielacolumn]').length > 0) {
				indexFindAll = '[data-numberschoser] tr';
				selectorNext ="[data-quinielacolumn]:not([data-isPlenoAl15]):eq("+(indexOfPage)+")"
				var nextSelector=$(indexFindAll).find(selectorNext);
				var totalSelector = $(indexFind).find(selector).length;
				var nextSelectorExtras = ""
			// Los demás
			} else {
				var nextSelector=$(indexFind).find(selector).eq(indexOfPage);
				var totalSelector = $(indexFind).find(selector).length;
				var nextSelectorExtras = $('[data-numberschoser]:eq(1)').find(selector).eq(indexOfPage);
			}



			if((parentObj.ignorePagerClicksOnDesktop==true && !Foundation.MediaQuery.atLeast('large')) || parentObj.ignorePagerClicksOnDesktop==false){
				var myAnimationDuration=300;
				var cssMyAnimationDuration=(myAnimationDuration/1000).toString()+"s";
				$(currElem).add(nextSelector).add(nextSelectorExtras).css("animation-duration",cssMyAnimationDuration).removeClass('reverse');
				$(currElem).addClass('movingOut').removeClass('reverse')
				setTimeout(function(){
					$(currElem).removeClass('active').removeClass('movingOut');
					$(currElem).parent().find('[data-actions]').removeClass('active');
					$(nextSelector).add(nextSelectorExtras).addClass('active').removeClass('reverse')
					$(nextSelector).parent().find('[data-actions]').addClass('active');
				}, myAnimationDuration)
			}

			if((parentObj.ignorePagerClicksOnDesktop==true && !Foundation.MediaQuery.atLeast('large')) || parentObj.ignorePagerClicksOnDesktop==false) { //Ejecuta solo en medium-small
				if (indexOfPage == 0) {
					$('[data-bt_navBoleto_Left]').addClass("disabled").attr('aria-disabled',true);
				} else {
					$('[data-bt_navBoleto_Left]').removeClass("disabled").removeAttr('aria-disabled');
				}
			}

			var max = $("[data-numabersPageSelect]").length - 1;
			if (max == 0) {
				max = 7;
			}
			if((parentObj.ignorePagerClicksOnDesktop==true && !Foundation.MediaQuery.atLeast('large')) || parentObj.ignorePagerClicksOnDesktop==false) { //Ejecuta solo en medium-small
				if (indexOfPage == max) {
					$('[data-bt_navBoleto_Right]').addClass("disabled").attr('aria-disabled',true);
				} else {
					$('[data-bt_navBoleto_Right]').removeClass("disabled").removeAttr('aria-disabled');
				}
			}

		}
	});

	$('[data-bt_navBoleto_Right]').off('click').click(function() {
		if ($("[data-extrasChooser] .row").length == 1) {
			var currElem=$('[data-numbersChoser]:not([data-extrasChooser]) ' + selector + '.active');
		} else {
			var currElem=$('[data-numbersChoser] ' + selector + '.active');
		}
		if (!$(this).hasClass("disabled")) {
			// Obtenemos el elemento actual en base al selector elegido y a su posicion en el DOM con respecto a los otros no activos
			var currentSelectorIndex=0;
			var i=0;

			if ($('[data-numberschoser] [data-quinielacolumn]:not([data-isPlenoAl15]):not([data-quinielacolumn=""]):not([data-columna-extra])').length == 0){
				var indexFind='[data-numberschoser]:eq(0)';
			} else {
				var indexFind='[data-numberschoser] tbody tr:eq(0)';
			}
			$(indexFind).find(selector).each(function() {
				if ($(this).hasClass('active')){
					currentSelectorIndex=i;
					return false;
				} else {
					i++;
				}
			});

			if ($('[data-numberschoser] [data-quinielacolumn]:not([data-quinielacolumn=""]):not([data-columna-extra])').length > 0) {
				indexFindAll = '[data-numberschoser] tr';
				selectorNext ="[data-quinielacolumn]:not([data-isPlenoAl15]):not([data-quinielacolumn='']):not([data-columna-extra]):eq("+(currentSelectorIndex+1)+")"
				var nextSelector=$(indexFindAll).find(selectorNext);
				var totalSelector = $(indexFind).find(selector).length;
				var nextSelectorExtras = "";
			} else {
				var nextSelector=$(indexFind).find(selector).eq(currentSelectorIndex+1);
				var totalSelector = $(indexFind).find(selector).length;
				var nextSelectorExtras = $('[data-numberschoser]:eq(1)').find(selector).eq(currentSelectorIndex+1);
			}

			var myAnimationDuration=300;
			var cssMyAnimationDuration=(myAnimationDuration/1000).toString()+"s";
			$(currElem).add(nextSelector).add(nextSelectorExtras).css("animation-duration",cssMyAnimationDuration).removeClass('reverse');
			$(currElem).addClass('movingOut').removeClass('reverse')
			setTimeout(function(){
				$(currElem).removeClass('active').removeClass('movingOut');
				$(currElem).parent().find('[data-actions]').removeClass('active')
				$(nextSelector).add(nextSelectorExtras).addClass('active').removeClass('reverse')
				$(nextSelector).parent().find('[data-actions]').addClass('active')
				parentObj.currentBet = currentSelectorIndex+1;
				updateNumbersPager();
			}, myAnimationDuration)
			if (currentSelectorIndex+1 == totalSelector-1) {
				$(this).addClass("disabled");
			}

			$('[data-bt_navBoleto_Left]').removeClass("disabled").removeAttr('aria-disabled');
		}
	});

	$('[data-bt_navBoleto_Left]').off('click').click(function() {
		if ($("[data-extrasChooser] .row").length == 1) {
			var currElem=$('[data-numbersChoser]:not([data-extrasChooser]) ' + selector + '.active');
		} else {
			var currElem=$('[data-numbersChoser] ' + selector + '.active');
		}
		if (!$(this).hasClass("disabled")) {

			// Obtenemos el elemento actual en base al selector elegido y a su posicion en el DOM con respecto a los otros no activos
	 		var currentSelectorIndex=0;
	 		var i=0;

	 		if($('[data-numberschoser] [data-quinielacolumn]').length == 0){
	 			var indexFind='[data-numberschoser]:eq(0)';
	 		}else{
	 			var indexFind='[data-numberschoser] tbody tr:eq(0)';
			}
	 		$(indexFind).find(selector).each(function(){
				if($(this).hasClass('active')){
					currentSelectorIndex=i;
					return false;
				}else{
					i++;
				}
			})
 			if($('[data-numberschoser] [data-quinielacolumn]').length > 0){
				indexFindAll = '[data-numberschoser] tr';
				selectorPrev ="[data-quinielacolumn]:not([data-isPlenoAl15]):eq("+(currentSelectorIndex-1)+")"
				var prevSelector=$(indexFindAll).find(selectorPrev);
				var prevSelectorExtras = ""
			}else{
			 	var prevSelector=$(indexFind).find(selector).eq(currentSelectorIndex-1);
			 	var prevSelectorExtras = $('[data-numberschoser]:eq(1)').find(selector).eq(currentSelectorIndex-1);
			}


			var myAnimationDuration=300;
			var cssMyAnimationDuration=(myAnimationDuration/1000).toString()+"s";
			$(currElem).add(prevSelector).add(prevSelectorExtras).css("animation-duration",cssMyAnimationDuration)
			$(currElem).addClass('movingOut').addClass('reverse')
			setTimeout(function(){
				$(currElem).removeClass('active').removeClass('reverse').removeClass('movingOut');
				$(currElem).parent().find('[data-actions]').removeClass('active')

				$(prevSelector).add(prevSelectorExtras).addClass('active').addClass('reverse')
				$(prevSelector).parent().find('[data-actions]').addClass('active')
				parentObj.currentBet = currentSelectorIndex-1;
				updateNumbersPager();
			}, myAnimationDuration)
				if (currentSelectorIndex-1 == 0) {
					$(this).addClass("disabled");
				}
			$('[data-bt_navBoleto_Right]').removeClass("disabled").removeAttr('aria-disabled');
		}
	});

	function getCombinaciones() {
		var param = "";
		var combinaciones = getCookie("combinacion").split("#").filter(function(v) { return v != ''; });
		var combinacionB;
		var combinacionN;
		var index;
		var combinacion;
		var combinacionArray;
		var modo = "directo";
		for(var i=0;i < combinaciones.length; i++) {
			if (combinaciones[i] != "") {
				combinacionB = combinaciones[i].split(":");
				index = combinacionB[0];
				combinacion = combinacionB[1];
				if (!parentObj.isQuiniela) {
					if (combinacion.indexOf(",") != -1) {
						combinacionN = combinacion.split(",");
						numbers = combinacionN[0];
						extras = combinacionN[1];
					} else {
						numbers = combinacion;
						extras = "";
					}
					if (index == 0) {
						numbersArray = numbers.split("-").filter(function(v) { return v != ''; });
						extrasArray = extras.split("-").filter(function(v) { return v != ''; });
						if (numbersArray.length > parentObj.betsToChooseSN || extrasArray.length > parentObj.extrasToChooseSN) {
							modo = "multiple";
							param = numbers.replace(/-/g , ",");
							if (extras != "" && !parentObj.extrasUnique) {
								param = param + "~" + extras.replace(/-/g , ",");
							}
							break;
						}
					}
					param = param + numbers.replace(/-/g , ",");
					if (extras != "" && !parentObj.extrasUnique) {
						param = param + "~" + extras.replace(/-/g , ",");
					}
					param = param + "-";
				} else {
					combinacionN = combinacion.split(",").filter(function(v) { return v != ''; });
					combinacionArray = Array();
					for (j=0; j<combinacionN.length; j++) {
						combinacionPos = combinacionN[j].split("-");
						if (combinacionPos[1] != "") {
							if (index == 0 && typeof combinacionArray[combinacionPos[0]] !== 'undefined') {
								combinacionArray[combinacionPos[0]] = combinacionArray[combinacionPos[0]] + combinacionPos[1].toUpperCase();
								modo = "multiple";
							} else {
								combinacionArray[combinacionPos[0]] = combinacionPos[1].toUpperCase();
							}
						}
					}
					if (modo == "multiple") {
						param = combinacionArray.toString().substring(1);
						break;
					} else {
						param = param + combinacionArray.toString().substring(1) + "-";
					}
				}
			}
		}

		return Array(modo, param);
	} //SOLO CG, con cookies

	function resetColumn(currElem) {
		$(currElem).animate({
		  opacity: 0,
		  left: "+=50",
		}, 200, function() {
			$(currElem).removeClass('active').prev(selector).addClass('active').css({'opacity':'0','left':'-50px'});
			$(currElem).prev(selector).animate({
			  opacity: 1,
			  left: "0",
			}, timeToAnim,function(){
				updateNumbersPager();
			})
		});
	}





	// Función para añadir números y extras al resumen del boleto


	function disableNonMultipleSummary(summaryTableElem, parentObj) {
		if (!parentObj.isQuiniela && !parentObj.isQuinigol) {
			$(summaryTableElem).find('tr:gt(0):not(#reintegro)').hide();
			$('[data-bt_navBoleto_Right]').addClass("disabled").attr('aria-disabled',true);
		}
		if (parentObj.isQuiniela || parentObj.isQuinigol) {
			$(summaryTableElem).find('td:gt(1):not([data-multiple-marker])').hide()
			$("#numbersChoserSummary").hide();
			$("#numbersChoserSummaryMultiple").show();
			$('[data-bt_navBoleto_Right]').addClass("disabled").attr('aria-disabled',true);
		}
	}

	function enableNonMultipleSummary(summaryTableElem, parentObj) {
		if (!parentObj.isQuiniela && !parentObj.isQuinigol) {
			$(summaryTableElem).find('tr:gt(0)').show()
			$('[data-bt_navBoleto_Right]').removeClass("disabled").removeAttr('aria-disabled');
		}
		if (parentObj.isQuiniela || parentObj.isQuinigol) {
			$(summaryTableElem).find('td:gt(1)').show()
			$("#numbersChoserSummary").show();
			$("#numbersChoserSummaryMultiple").hide();
			$('[data-bt_navBoleto_Right]').removeClass("disabled").removeAttr('aria-disabled');
		}
	}



	function updateNumbersPager() {
		parentObj.updatePager();
	}




	$("[data-trash]").off("click").on("click",function() {
		if (!parentObj.isQuiniela) {
			parentObj.removeSingleColumn($(this).closest("[data-columna]").index());
		}else{
			parentObj.removeSingleColumn($(this).closest("[data-quinielacolumn]").index() - parentObj.firstPlayableCol);
		}
	});


	this.attachRandomEvents();

}

numberChooser.prototype.updatePager = function(){
	var parentObj=this;
	$(".numbersChoserPages li").removeClass("active");//.addClass("disabled");
	var index = parentObj.currentBet;//parentObj.currentRow;
	$(".numbersChoserPages li:eq(" + index + ")").addClass("active").removeClass("disabled");
}
numberChooser.prototype.clearPager = function(){
	var parentObj=this;
	$(".numbersChoserPages li").removeClass();//.addClass("disabled");
	var index = parentObj.currentBet;//parentObj.currentRow;
	$(".numbersChoserPages li:eq(" + index + ")").addClass("active");
}

numberChooser.prototype.attachRandomEvents = function(){
	var parentObj=this;
	$("[data-shuffle]").off('click').click(function() {
		if (!parentObj.isQuiniela) {
			var elem = $(this).closest("[data-columna]");
			if(!$(elem).hasClass("disabled")){
				parentObj.setRandom($(elem).index(),{onMarkedCallback: parentObj.onRandomCallback});
			}
		}else{
			var elem = $(this).closest("[data-quinielacolumn]");
			if(!$(elem).hasClass("disabled")){
				parentObj.setRandom($(elem).index() - parentObj.firstPlayableCol,{onMarkedCallback: parentObj.onRandomCallback});
			}
		}
	});
}

numberChooser.prototype.markPager =	function (status, row) {
	var changingClasses="animated bounceIn";
	var doneClasses="done";
	var emptyClasses="disabled";
	var incompleteClasses="incomplete";

	switch (status) {
		case "done":
			if (!$('.numbersChoserPages li:eq('+row+')').hasClass(doneClasses)) {
				$('.numbersChoserPages li:eq('+row+')').removeClass(emptyClasses).removeClass(incompleteClasses).addClass(changingClasses).addClass(doneClasses);
			}else{
				$('.numbersChoserPages li:eq('+row+')').removeClass(changingClasses)
			}
		break;

		case "incomplete":
			if (!$('.numbersChoserPages li:eq('+row+')').hasClass(incompleteClasses)) {
				$('.numbersChoserPages li:eq('+row+')').removeClass(doneClasses).removeClass(emptyClasses).addClass(changingClasses).addClass(incompleteClasses);
			}else{
				$('.numbersChoserPages li:eq('+row+')').removeClass(changingClasses)
			}
		break;

		case "empty":
			$('.numbersChoserPages li:eq('+row+')').removeClass(doneClasses).removeClass(incompleteClasses).addClass(changingClasses);
		break;
	}
}

numberChooser.prototype.revertClick = function(){
	this.revertClickAction = true;
}
numberChooser.prototype.reDoLastAction = function(){
	$(this.lastPressedElement).trigger('change');
}


numberChooser.prototype.resetBoleto = function (customResetBoletoCallback){
	var parentObj=this;

	$('[data-numberschoser] [data-columna] .active').add('[data-numberschoser] [data-columna-extra] .active').removeClass('active');
	$('[data-numberschoser] [data-quinielacolumn].active').removeClass('active');
	$('[data-numberschoser] [data-quinielacolumn] input').add('[data-numberschoser] [data-columna] input').add('[data-extrasChooser] input').prop("checked",false);
	$('[data-numberschoser] [data-quinielacolumn] label[data-value]').add('[data-numberschoser] [data-columna] label[data-value]').removeClass('active')
	$('[data-numberschoser] [data-columna] > .row:eq(0)').addClass('active')
	$('[data-numberschoser] [data-columna]:eq(0) [data-actions]').addClass('active');
	$('[data-numberschoser] [data-columna]:eq(0) [data-actions] button').removeAttr('disabled');

	$('[data-numberschoser] [data-quinielacolumn="0"]').addClass('active')

	$('[data-columna-extra] > .row.active').removeClass('active')
	$('[data-columna-extra] > .row:eq(0)').addClass('active');

	if(!this.isSetToMultiple && !this.isSetToReducida && !this.isSetToCondicionada){
		$('[data-numbersChoser]').removeAttr('data-isMultiple');
		$('[data-boleto]').removeAttr('data-isMultiple');
	}else{
		if(typeof $('[data-numbersChoser]').attr('data-isMultiple') != "undefined"){
			$('[data-numbersChoser]').attr('data-isMultiple',false);
		}
		if(typeof $('[data-boleto]').attr('data-isMultiple') != "undefined"){
			$('[data-boleto]').attr('data-isMultiple',false);
		}
	}

	parentObj.isReducidaInProgress = false;
	parentObj.isMultipleInProgress = false;
	parentObj.isCondicionadaInProgress = false;

	parentObj.currentRow = 0;
	parentObj.currentBet = 0;
	parentObj.correctBets = 0;
	parentObj.apuestas = 0;
	parentObj.incompleteBets = 0;
	parentObj.hasBetsAfterFirst=false;
	parentObj.lastPressedElement = false;
	parentObj.revertClickAction = false;
	parentObj.multipleChecked = 0;

	parentObj.multipleRawValues = {};
	parentObj.rawApuesta = new Array();

	parentObj.checkColumnasCompletadasCache = {
		correct: 0,
		incomplete: 0,
		halfBaked: 0,
		empty: parentObj.betsPerTicket
	}

	if(parentObj.hasExtrasOut){
		parentObj.checkColumnasCompletadasCache["incompleteExtras"] = parentObj.extrasToChooseSN;
	}
	if(parentObj.extrasUnique){
		parentObj.checkColumnasCompletadasCache["emptyUniqueExtras"] = parentObj.extrasToChooseSN;
	}


/*
	$('[data-numberschoser]').removeAttr('data-isMultiple data-isCondicionada data-isReducida')
	$('.numbersChoserPages li').removeClass().addClass('disabled');
	$('.numbersChoserPages li:eq(0)').addClass('active').removeClass('disabled');
*/
	parentObj.currentRow=0;
// 	this.currentBetQuini = 0;
// 	this.currentBet = 0;
	//Si se le pasa un callback, lo establece en el objeto
	if(typeof customResetBoletoCallback != "undefined"){
		parentObj.onResetBoletoCallback=customResetBoletoCallback;
		parentObj.onResetBoletoCallback();
	}
	parentObj.clearPager()

}

numberChooser.prototype.checkModeLayout = function (){
	//Devuelve si el Layout es normal o compacto en función de la visibilidad de las columnas
	var columnas=$('[data-numbersChoser] [data-columna]').length;
	var columnasVisibles=$('[data-numbersChoser] [data-columna] > .row:visible').length;
	if(columnas!=columnasVisibles) { this.isCompactMode=true }
}

numberChooser.prototype.switchExtras = function(status){
	var parentObj = this;
	if(status === true){
		this.hasExtrasOut = true;
		this.resetExtraColumns();
	}
	if(status === false){
		this.hasExtrasOut = false;
		if(!parentObj.isReducidaInProgress && !parentObj.isCondicionadaInProgress && !parentObj.isSetToCondicionada && !parentObj.isSetToReducida){
			delete parentObj.rawApuesta["elige8"];
			this.resetExtraColumns();
		}
	}
	if(parentObj.isMultipleInProgress || parentObj.isReducidaInProgress || parentObj.isCondicionadaInProgress || parentObj.isSetToCondicionada || parentObj.isSetToReducida || parentObj.isSetToMultiple){
		parentObj.onClickedMultipleCallback(parentObj)
	}
}

numberChooser.prototype.checkColumnasCompletadas = function(returnAsObject){ //Devuelve el número de columnas CORRECTAS de la apuesta, en negativo si hay correctas pero también incorrectas,  o false si ninguna lo es.
			var parentObj=this;
			var hasExtra = parentObj.hasExtras;
			var extrasUnique = parentObj.extrasUnique;
			var allCorrect = true;
			var numberOfCorrect = 0;
			var numberOfIncompletes = 0;
			var numberOfEmpty = 0;
			var numberOfExtrasIncomplete = 0;
			var numberOfUniqueExtrasEmpty = 0;
			var numberOfP15Incomplete = 0;

			parentObj.hasBetsAfterFirst=false;
			var userCombArray=new Array();
			var returnAsObj = false;
			if(typeof returnAsObject != "undefined" & returnAsObject === true){
				returnAsObj = true;
			}
			if(!parentObj.isQuiniela && !parentObj.isQuinigol){
				$("[data-numberschoser]:not([data-extraschooser]) [data-columna]").each(function() {

					var numbers=$(this).find('.column.active input');

					var numberOfNumbers = $(this).find('.column.active').length
					var numbersIndex = $(this).find(".row").attr("data-index");
					var checkedExtrasArray=new Array();
					var emptyExtras = false;
					var columnCorrect = true;

					if (hasExtra && !extrasUnique) {
						var extras=$("[data-columna-extra] [data-index='" + numbersIndex + "']").find(".column.active input");

						var numberOfExtras = $("[data-columna-extra] [data-index='" + numbersIndex + "']").find(".column.active input").length;
						if (
								(numberOfExtras  < parentObj.extrasToChooseSN && numberOfExtras  != 0) ||
								(numberOfNumbers < parentObj.betsToChooseSN  && numberOfNumbers != 0) ||
								(numberOfExtras  == parentObj.extrasToChooseSN && numberOfNumbers < parentObj.betsToChooseSN) ||
								(numberOfNumbers == parentObj.betsToChooseSN && numberOfExtras  < parentObj.extrasToChooseSN)
							) {
							allCorrect = false;
							columnCorrect = false;
						}
						if (numberOfExtras  == parentObj.extrasToChooseSN && numberOfNumbers == parentObj.betsToChooseSN) {
							numberOfCorrect = numberOfCorrect + 1;
						}else if(numberOfExtras < parentObj.extrasToChooseSN){
							numberOfExtrasIncomplete++;
						}
						if (numbersIndex>0 && (numberOfExtras>0 || numberOfNumbers>0)){
							parentObj.hasBetsAfterFirst=true;
						}

						if (allCorrect && numberOfExtras>0){
							var checkedExtrasArray=returnCheckedAsArray(extras);
						}

						if(numberOfExtras == 0){
							emptyExtras = true;
							columnCorrect = false;
						}

					} else {
						if ((numberOfNumbers < parentObj.betsToChooseSN && numberOfNumbers != 0) && !parentObj.isMultipleWithLessInProgress) {
							allCorrect = false;
							columnCorrect = false;

						}
						var numbersIndex = $(this).find(".row").attr("data-index");
						if (hasExtra && extrasUnique) {
							var extras=	$("[data-columna-extra] [data-index='0'] .column.active input");
							var numberOfExtras = $("[data-columna-extra] [data-index='0'] .column.active input").length;
							if (numberOfExtras == 0) {
								allCorrect = false;
								columnCorrect = false;
								emptyExtras = true;
								numberOfUniqueExtrasEmpty = 1;
							}else if(numberOfExtras < parentObj.extrasToChooseSN){
								numberOfExtrasIncomplete++;
							}

						}

						if(parseInt(numbersIndex)>0 ){ //es una columna diferente a la primera
							if($(this).find('.column.active').length>0){
								parentObj.hasBetsAfterFirst=true;
							}
						}

						if (parentObj.isMultipleWithLessInProgress && parentObj.hasBetsAfterFirst){
							allCorrect = false;
							columnCorrect = false;

						}

						if ( numberOfNumbers == parentObj.betsToChooseSN || (parentObj.isMultipleWithLessInProgress && (numberOfNumbers == (parentObj.betsToChooseSN-1) && !parentObj.hasBetsAfterFirst) ) || (parentObj.growingBetsMode && (numberOfNumbers >= parentObj.minNumeros && numberOfNumbers <= parentObj.maxNumeros) )){
							if(columnCorrect){
								numberOfCorrect = numberOfCorrect + 1;
							}
						}

						if (allCorrect){
							var checkedExtrasArray=returnCheckedAsArray(extras);
						}
					}
					if(allCorrect==false){
						numberOfIncompletes++;
						parentObj.boletoSnapshot[numbersIndex].status = 2;

					}
					if( (numberOfNumbers == 0 && !parentObj.hasExtras) || (numberOfNumbers == 0 && parentObj.hasExtras && !parentObj.extrasUnique && emptyExtras) || (numberOfNumbers == 0 && parentObj.hasExtras && parentObj.extrasUnique) ){
						numberOfEmpty++;
						parentObj.boletoSnapshot[numbersIndex].status = 0;

					}

	/*
				if(allCorrect==false && numbersIndex >0){
						parentObj.hasBetsAfterFirst=true;
					}
*/
					if(allCorrect){
						var checkedNumArray=returnCheckedAsArray(numbers);
						if(checkedNumArray.length>0){
							if(hasExtra && !extrasUnique){
								userCombArray.push ( {nums:checkedNumArray,extras:checkedExtrasArray})
							}else if(hasExtra && extrasUnique){
/*
								if(numbersIndex==0){
									if(typeof parentObj.rawApuesta.joker!="undefined" && parentObj.rawApuesta.joker==1){
										userCombArray.push ( {nums:checkedNumArray,extras:checkedExtrasArray,joker:1})
										userCombArray.joker = 1
									}else{
										userCombArray.push ( {nums:checkedNumArray,extras:checkedExtrasArray})
									}
								}else{
									userCombArray.push ( {nums:checkedNumArray})
								}
*/
								if(userCombArray.length == 0){
									if(typeof parentObj.rawApuesta.joker!="undefined" && parentObj.rawApuesta.joker==1){
										userCombArray.push ( {nums:checkedNumArray,extras:checkedExtrasArray,joker:1})
										userCombArray.joker = 1
									}else{
										userCombArray.push ( {nums:checkedNumArray,extras:checkedExtrasArray})
									}
								}else{
									userCombArray.push ( {nums:checkedNumArray})

									if(checkedExtrasArray.length > 0){
										userCombArray[0].extras = checkedExtrasArray
									}
									if(typeof parentObj.rawApuesta.joker != "undefined" && parentObj.rawApuesta.joker==1){
										userCombArray[0].joker = 1
									}
								}
							}else{
								userCombArray.push ( {nums:checkedNumArray})
							}
							parentObj.boletoSnapshot[numbersIndex].status = 1;
						}
					}


				});


				if(userCombArray.length>0){
					parentObj.rawApuesta=userCombArray;
				}
			}else{ //Quiniela y Quinigol
				//console.log(parentObj.currentRow)
				//var current
				//if(!parentObj.isShuffleInProgress){ //Pausamos este proceso si estamos haciendo una aleatoria para no reiterar en cada click
					var firstColCorrectTemp=0;
					var userCombArray = new Array();
					var obj = {};

					if (!parentObj.isCondicionadaInProgress && !parentObj.isReducidaInProgress){
						var elige8_elems = $('[data-quinielacolumn][data-columna-extra] label.active');
					}else{
						var extra_elems = $('[data-quinielacolumn][data-columna-extra] label.active');
					}


					$("[data-numberschoser] tr").not('thead tr').find("td[data-quinielacolumn][data-index='0']").each(function() {
						var numbers = $(this).find("label[data-value].active input");
						var length = $(this).find("label[data-value].active input").length;
						if (length == 0) {
							allCorrect = false;
							return false;
						}
						var key = $(this).closest('tr').attr('data-row');
						obj[key]= returnCheckedAsArray(numbers);
						firstColCorrectTemp++;
					});

					$("[data-numberschoser] tr").not('thead tr').find("td[data-quinielacolumn][data-index='0'][data-isPlenoAl15]").each(function() {
						var numbers = $(this).find("label[data-value].active input");
						var length = $(this).find("label[data-value].active input").length;
						if(length == 0){
							allCorrect = false;
							numberOfP15Incomplete++;
						}
					})
					numberOfP15Incomplete > 0 ? parentObj.incompleteP15 = numberOfP15Incomplete : parentObj.incompleteP15 = null;

					if(firstColCorrectTemp > 0 && firstColCorrectTemp < 16){
						allCorrect = false;
						numberOfIncompletes++;
					}else if(firstColCorrectTemp == 0){
						allCorrect = false;
						numberOfEmpty++;
					}

					if (allCorrect) {
						numberOfCorrect++;
						userCombArray.push(obj);
					}

					for (i=1;i<8;i++) { //Columnas restantes
						var numbers = $("[data-numberschoser] tr").find("td[data-quinielacolumn][data-index='"+i+"'] label[data-value].active input");
						var length = $("[data-numberschoser] tr").find("td[data-quinielacolumn][data-index='"+i+"'] label[data-value].active input").length;
						if (length != 14 && length != 0) {
							allCorrect = false;
						}
						if (length == 14) {
							numberOfCorrect++;
							userCombArray.push(returnCheckedAsArray(numbers));
						}
						if (length > 0){
							parentObj.hasBetsAfterFirst=true;
						}

						if (length > 0 && length < 14){
							numberOfIncompletes++;
						}

						if (length == 0){
							numberOfEmpty++;
						}
					}
					if(parentObj.incompleteP15 != null){
						allCorrect = false;
					//Elige8
					}else if((typeof elige8_elems != "undefined" &&  ( $(elige8_elems).length > 0 && $(elige8_elems).length != parentObj.extrasToChooseSN)) || (parentObj.hasExtrasOut && (typeof elige8_elems == "undefined" || (typeof elige8_elems != "undefined" && $(elige8_elems).length == 0) ) ) && !parentObj.isCondicionadaInProgress && !parentObj.isReducidaInProgress && !parentObj.isSetToCondicionada && !parentObj.isSetToReducida){
						if(allCorrect){
							parentObj.completeButIncompleteExtras = true;
						}
						allCorrect = false;
// 						numberOfIncompletes++;
						numberOfExtrasIncomplete = parentObj.extrasToChooseSN - $(elige8_elems).length;
					}else if(typeof elige8_elems != "undefined" &&  ($(elige8_elems).length == parentObj.extrasToChooseSN || $(elige8_elems).length == 0) && !parentObj.isCondicionadaInProgress && !parentObj.isReducidaInProgress && !parentObj.isSetToCondicionada && !parentObj.isSetToReducida){
						var values = new Array();
						$(elige8_elems).each(function(){
							values.push($(this).attr('data-value'));
						})
						if(values.length > 0){
							parentObj.setExtrasRawValues({
								extra:["elige8",values]
							})
						}
						if(allCorrect){
							parentObj.completeButIncompleteExtras = false;
							numberOfExtrasIncomplete = 0;
						}
					}else if(parentObj.isCondicionadaInProgress || parentObj.isReducidaInProgress ||parentObj.isSetToCondicionada || parentObj.isSetToReducida){
/*
						if( $(extra_elems).length == 0){
							numberOfExtrasIncomplete = 1;
						}
*/
					}

				//}
			}
// 			if ( (!parentObj.isShuffleInProgress && !parentObj.isMultipleWithLessInProgress) || (!parentObj.isShuffleInProgress && parentObj.isMultipleWithLessInProgress) || (parentObj.isShuffleInProgress && !parentObj.isMultipleWithLessInProgress) ){
// 			if ( !parentObj.isMultipleWithLessInProgress ){
				returnObj = {
					correct: numberOfCorrect,
					incomplete: numberOfIncompletes,
					halfBaked: parentObj.betsPerTicket-numberOfCorrect-numberOfEmpty,
					empty: numberOfEmpty,
					incompleteExtras:numberOfExtrasIncomplete,
					emptyUniqueExtras:numberOfUniqueExtrasEmpty
				}

				parentObj.checkColumnasCompletadasCache = returnObj;
				if ( (allCorrect && numberOfCorrect != 0) || (!allCorrect && numberOfCorrect != 0) ) {
					if(allCorrect && numberOfCorrect != 0){
						var returnValue=numberOfCorrect;
					}else{
						var returnValue=numberOfCorrect*(-1);
					}

					parentObj.correctBets = Math.abs(returnValue);

					if(!(parentObj.isMultipleInProgress && !parentObj.isCondicionadaInProgress && !parentObj.isReducidaInProgress) ){
						parentObj.apuestas=parentObj.correctBets
					}

					parentObj.incompleteBets=numberOfIncompletes;
					if(numberOfCorrect >= parentObj.minBetsPerTicket || (numberOfCorrect < parentObj.minBetsPerTicket && (parentObj.isMultipleInProgress || parentObj.isCondicionadaInProgress || parentObj.isReducidaInProgress) )){
						if(userCombArray.length>0){
							if(typeof parentObj.rawApuesta["elige8"] != "undefined"){
								var backup = parentObj.rawApuesta["elige8"];
								parentObj.rawApuesta=userCombArray;
								parentObj.rawApuesta["elige8"] = backup
							}else{
								parentObj.rawApuesta=userCombArray;
							}
						}
						if(parentObj.incompleteBets == 0){
							//Esta línea se ha agregado para contemplar casos de elige8 de quiniela.
							//Podría presentar problemas
							parentObj.onTodasColumnasCompletadasCallback(parentObj,returnObj);
						}
					}else{
						//También registramos cuando bonoloto tenga 1 correcta, aunque no marque el boleto como correcto, pero sí como apuesta valida.
						//P.ej., Valido para evaluar si son semanales.
						if(numberOfCorrect==1 && !parentObj.isMultipleInProgress /* && !parentObj.isQuiniela && !parentObj.isQuinigol */){
							parentObj.apuestas=1;
							if(userCombArray.length>0){
								if(typeof parentObj.rawApuesta["elige8"] != "undefined"){
									var backup = parentObj.rawApuesta["elige8"];
									parentObj.rawApuesta=userCombArray;
									parentObj.rawApuesta["elige8"] = backup
								}else{
									parentObj.rawApuesta=userCombArray;
								}
							}
							parentObj.onTodasColumnasCompletadasCallback(parentObj,returnObj);
						}
					}

					if(!returnAsObj){
						return returnValue;
					}else{
						return returnObj;
					}
				}else{
					parentObj.correctBets=numberOfCorrect;
					if(!(parentObj.isMultipleInProgress && !parentObj.isCondicionadaInProgress && !parentObj.isReducidaInProgress) ){
						parentObj.apuestas=Math.abs(numberOfCorrect);
					}
					parentObj.incompleteBets=numberOfIncompletes;
					if(numberOfCorrect <= 0  && (parentObj.isQuiniela || parentObj.isQuinigol)){
						parentObj.rawApuesta = new Array();
					}
					if(!returnAsObj){
						return numberOfCorrect;
					}else{
						return returnObj;
					}
				}
// 			}

			function returnCheckedAsArray(checkedElems){
				var numbersArray=new Array();
				$(checkedElems).each(function(){
					if($(this).prop('checked') || $(this).closest('label[data-value]').hasClass('active') || $(this).closest('.column').hasClass('active')){
						numbersArray.push($(this).val())
					}
				})
				return numbersArray;
			}

		}
numberChooser.prototype.removeSingleColumn = function (colIndexToRemove){
	var parentObj=this;
	if (parentObj.allowsDelete) {
		var index = colIndexToRemove;
		if (!parentObj.isQuiniela) {

			$("[data-columna] [data-index='" + index + "'] .column.active").removeClass('active').find('input').prop('checked',false);
			$("[data-columna-extra] [data-index='" + index + "'] .column.active").removeClass('active').find('input').prop('checked',false);

			if(typeof parentObj.rawApuesta[index]!="undefined"){
				parentObj.rawApuesta.splice(index,1);
			}
			if(index!=0){
				parentObj.isMultipleInProgress=false;
				parentObj.isReducidaInProgress=false;
				parentObj.checkColumnasCompletadas();
				parentObj.onAnyColumnEmptyCallback(parentObj);
			}else{
				parentObj.checkColumnasCompletadas();
				if(parentObj.isMultipleInProgress){
					parentObj.onClickedMultipleCallback(parentObj,0,parentObj.maxBetsForDirectML);
					parentObj.isMultipleInProgress=false;
					parentObj.isReducidaInProgress=false;
					if(!parentObj.isSetToMultiple && !parentObj.isSetToReducida && !parentObj.isSetToCondicionada){
						$('[data-boleto]').removeAttr('data-isMultiple');
					}else{
						if(typeof $('[data-boleto]').attr('data-isMultiple') != "undefined"){
							$('[data-boleto]').attr('data-isMultiple',false);
						}
					}
				}
				parentObj.multipleRawValues = {};
				parentObj.onAnyColumnEmptyCallback(parentObj);
			}
			parentObj.markPager("empty",index)
			parentObj.boletoSnapshot[index].status = 0;

		} else {

			$("[data-numberschoser] tr td[data-quinielacolumn='" + index + "'] [data-value]").removeClass('active').find('input').prop('checked',false);
			$("[data-numberschoser] td[data-quinielacolumn='0']").removeAttr('data-mult-num-bis data-mult-num');

			if(index!=0){
				parentObj.isMultipleInProgress=false;
				parentObj.isReducidaInProgress=false;
				parentObj.checkColumnasCompletadas();
				parentObj.onAnyColumnEmptyCallback(parentObj);
				if(typeof parentObj.rawApuesta[index]!="undefined"){
					parentObj.rawApuesta.splice(index,1);
				}
			}else{
				if(typeof parentObj.rawApuesta[index]!="undefined"){
					delete parentObj.rawApuesta[index];
				}
				if(parentObj.isCondicionadaInProgress || parentObj.isReducidaInProgress){
					$("[data-numberschoser] tr td[data-quinielaColumn][data-columna-extra] label").removeClass('active').find('input').prop('checked',false);
				}
				parentObj.checkColumnasCompletadas();
				if(parentObj.isCondicionadaInProgress || parentObj.isReducidaInProgress || parentObj.isSetToReducida || parentObj.isSetToCondicionada){
					$("[data-numberschoser] tr td[data-quinielaColumn][data-columna-extra] label").addClass('disabled');
				}
				if( parentObj.isMultipleInProgress || parentObj.isSetToMultiple){
					if (!parentObj.isCondicionadaInProgress && !parentObj.isReducidaInProgress && !parentObj.isSetToReducida && !parentObj.isSetToCondicionada){
						$("[data-numberschoser] tr td[data-quinielaColumn][data-columna-extra] label").removeClass('disabled');
					}
				}
				if(parentObj.isMultipleInProgress){
					parentObj.onClickedMultipleCallback(parentObj,0,parentObj.maxBetsForDirectML);
					parentObj.isMultipleInProgress=false;
					parentObj.isReducidaInProgress=false;
					//$('[data-boleto]').removeAttr('data-isMultiple');
				}
				parentObj.multipleRawValues = {};
				parentObj.onAnyColumnEmptyCallback(parentObj);
			}

			if(typeof $("[data-numberschoser] tr td[data-quinielacolumn='" + index + "']").attr('data-columna-extra') == "undefined"){
				parentObj.markPager("empty",index)
				parentObj.boletoSnapshot[index].status = 0;
			}
		}

		if(parentObj.progressiveColumns){
			parentObj.purgeEmptyColumns();
		}
	}
}

numberChooser.prototype.clearColumnsForMultiple = function(){
	var parentObj=this;
	if (!this.isQuiniela) {
		$("[data-columna]").each(function(){
			var index = $(this).index();
			if(index>0){
				parentObj.removeSingleColumn(index);
			}
		})
	} else {
		$("[data-numberschoser] tbody tr:eq(0) td[data-quinielacolumn]").each(function() {
			var index = $(this).attr('data-quinielaColumn');
			//Si es multiple sin condicionadas ni reducidas
			//No limpiamos los extras (que serían elige8), para no perderlos
			if(parentObj.isSetToCondicionada || parentObj.isSetToReducida || parentObj.isCondicionadaInProgress || parentObj.isReducidaInProgress){
				if(index>0){
					parentObj.removeSingleColumn(index);
				}
			}else{
				if( index>0 && typeof $(this).attr('data-columna-extra') == "undefined" ){
					parentObj.removeSingleColumn(index);
				}
			}

		});
	}
/*
	if(parentObj.progressiveColumns){
		parentObj.blockAllColumns(0);
	}
*/
}
numberChooser.prototype.resetExtraColumns = function(){
	var parentObj=this;
	$("[data-numberschoser] td[data-quinielacolumn][data-columna-extra] [data-value].active").removeClass('disabled active').find('input').removeAttr('disabled').prop("checked",false);
	$("[data-numberschoser] td[data-quinielacolumn=0]").attr('data-mult-num-bis','1')
	parentObj.multipleRawValues={}
	parentObj.apuestas = 0;
	parentObj.checkColumnasCompletadas();
	parentObj.isReducidaInProgress=false;
}
numberChooser.prototype.setRandom = function(colIndexToInject,options){
		// numberChooser.setRandom(2)
		//
		// numberChooser.setRandom(2,{
		// 		custom: {
		//			nums: 6,
		//			extras: 2,
		//			reduccionId:"1022" //opcional
		//		}
		// })
		//
		// numberChooser.setRandom(0,{
		// 		custom: {
		//			deDos: 6,
		//			deTres: 2,
		//			reduccionId:"1022" //opcional
		//		}
		// })

		var parentObj=this;

		var customMaxNumber = 	this.betsToChooseML; 	//Máximo de marcados para múltiples/reducciones
		var customMinNumber =	this.betsToChooseSN;	//Mínimo de marcados por apuesta
		var customMaxExtras =	0;						//Máximo de marcados EXTRA para múltiples/reducciones
		var customMinExtras =	0;						//Mínimo de marcados EXTRA por apuesta
		var isMultiple = false;

		var customQuiniDeDos = 0;
		var customQuiniDeTres = 0;
		var onMarkedCallback = function(){}

		if(typeof this.extrasToChooseML != "undefined") { customMaxExtras = this.extrasToChooseML; }	//Máximo de marcados EXTRA para múltiples/reducciones
		if(typeof this.extrasToChooseSN != "undefined") { customMinExtras = this.extrasToChooseSN; }	//Mínimo de marcados EXTRA por apuesta


		var customNums = customMinNumber;
		var customExtras = customMinExtras;
		var customReduccionId = false;
		var customReduccion = false;
// 		var customApuestas = false;

		parentObj.currentRow = colIndexToInject;

		if(typeof options != "undefined"){
			if(typeof options.custom != "undefined"){

				if(typeof options.custom.nums != "undefined"){ //Acotamos los valores por si al llamarlo pasamos valores que se salen del rango del juego
						customNums=options.custom.nums;
				}

				if(typeof options.custom.extras != "undefined"){ //Acotamos los valores por si al llamarlo pasamos valores que se salen del rango del juego
						customExtras=options.custom.extras
				}

				if(typeof options.custom.reduccionId != "undefined"){ //Acotamos los valores por si al llamarlo pasamos valores que se salen del rango del juego
						customReduccionId=options.custom.reduccionId
				}

				if(typeof options.custom.reduccion != "undefined"){ 	//Para reducciones personalizadas, pasamos la optimizacion
						customReduccion=options.custom.reduccion
				}

				if(typeof options.custom.deDos != "undefined"){ //Acotamos los valores por si al llamarlo pasamos valores que se salen del rango del juego
					if(options.custom.deDos<=14 && options.custom.deDos>=0){
						customQuiniDeDos=options.custom.deDos;
					}
				}

				if(typeof options.custom.deTres != "undefined"){ //Acotamos los valores por si al llamarlo pasamos valores que se salen del rango del juego
					if(options.custom.deTres<=14 && options.custom.deTres>=0){
						customQuiniDeTres=options.custom.deTres;
					}
				}

			}
				if(typeof options.onMarkedCallback != "undefined") { onMarkedCallback = options.onMarkedCallback; }

		}

		if(customNums>customMinNumber || customExtras>customMinExtras || customQuiniDeTres!=0 || customQuiniDeDos!=0 || (parentObj.allowsMultipleWithLess===true && customNums==5) ){
			isMultiple=true;
			parentObj.clearColumnsForMultiple()
		}

		if (parentObj.allowsRandom) {
			var lastNumberIndex = false;
			var reduccionId = false;
			parentObj.isShuffleInProgress = true;

			if (!parentObj.isQuiniela) { //En el caso de números normales, los cálculos se hacen al final. Se inhiben durante el change, si shuffle se está produciendo.

				parentObj.removeSingleColumn(colIndexToInject);
				var index = colIndexToInject;
				var numbers = $("[data-columna]:eq(" + index + ")").find(".column label");
				for (var i = 0; i < customNums; i++) {
					var random = Math.floor((Math.random() * (numbers.length)));
					$(numbers[random]).find('input').prop('checked',true).trigger('change');
					numbers.splice(random, 1);
				}

				//Si los extras unicos externos no están ya elegidos, los hacemos aleatorios
				if(parentObj.hasExtras && parentObj.extrasUnique && parentObj.hasExtrasOut){
					var extrasAlreadyChosen = parentObj.areExtrasAlreadyChosen();
				}else{
					var extrasAlreadyChosen = false;
				}
				if(!extrasAlreadyChosen){
					if (parentObj.extrasUnique) {
						$("[data-columna-extra]:eq(0)").find(".column.active label input").prop('checked',true).trigger("change");
						var extras = $("[data-columna-extra]:eq(0)").find(".column label");
					}else{
						var extras = $("[data-columna-extra]:eq(" + index + ")").find(".column label");
					}
					for (var i = 0; i < customExtras; i++) {
						var random = Math.floor((Math.random() * (extras.length)));
						$(extras[random]).find('input').prop('checked',true).trigger('change');
						extras.splice(random, 1);
					}
				}
				parentObj.markPager('done', index);
				parentObj.boletoSnapshot[parentObj.getActiveColumn()].status = 1;
				if(parentObj.progressiveColumns){
					parentObj.unblockColumn(parentObj.getActiveColumn()+1);
				}
				if (index == 0) {
					if(!isMultiple){
						parentObj.isMultipleInProgress=false;
						parentObj.isReducidaInProgress=false;
						parentObj.onEnableNonMultipleSummaryCallback();
					}else{
						parentObj.isMultipleInProgress=true;
						if( customNums > parentObj.minNumerosReduccion){
							parentObj.isReducidaInProgress=true;
						}
						parentObj.onDisableNonMultipleSummaryCallback();
						parentObj.onClickedMultipleCallback(parentObj,$("[data-numberschoser]:not([data-extraschooser]) [data-index='0'] .column.active").length, $("[data-extraschooser] [data-index='0'] .column.active").length,parentObj.maxBetsForDirectML);

						//Establecemos las reducciones en el panel
						if(customReduccionId!==false){
							var elem=$('[data-reducciones-option][data-reducciones-id='+customReduccionId+']:eq(0)');
							if($(elem).length!=0){
								$(elem).trigger('click');
							}else{
								$('[data-select-personalizada-numero] option').each(function(){
									if($(this).text()==customReduccion){
										$(this).prop('selected',true);
										$(this).parent().trigger('change');
										$('[data-select-personalizada-apuestas] option[data-reducciones-id="'+customReduccionId+'"]').prop('selected',true).parent().trigger('change').closest('tr[data-customMultiple]').trigger('click');
									}
								})
							}
						}
					}
					var colStatus = {}

					colStatus["col"] = 	colIndexToInject;
					colStatus["numbers"] = parentObj.betsToChooseSN;
					colStatus["numbersRemaining"] = 0;
					if(parentObj.hasExtras){
						colStatus["extras"] = parentObj.extrasToChooseSN;
					}else{
						colStatus["extras"] = 0;
					}
					colStatus["extrasRemaining"] = 0;
					parentObj.checkColumnasCompletadas();

					parentObj.onOneNumberSelectedCallback();
					parentObj.onFirstColumnDoneCallback(parentObj,colStatus);
				}
			} else {
				var colStatus = {
				}
				var index=colIndexToInject;
				parentObj.removeSingleColumn(colIndexToInject);
				$("[data-numberschoser] tr").each(function() {
					var random = Math.floor((Math.random() * 3));
// 					$(this).find("[data-quinielacolumn]:not([data-isplenoal15])").eq(index).find("input[data-value]:eq(" + random + ")").trigger("change");
					var elem=$(this).find("[data-quinielacolumn]:not([data-isplenoal15])").eq(index).find("input[data-value]:eq(" + random + ")");
					$(elem).prop('checked',true).closest('label').addClass('active');
					lastNumberIndex=$(elem);
				});
				if (index == 0) {
					var random = Math.floor((Math.random() * 4));
// 					$("[data-isplenoal15]:eq(0)").find("input[data-value]:eq(" + random + ")").trigger("change");
					$("[data-isplenoal15]:eq(0) input[data-value]:eq(" + random + ")").prop('checked',true).closest('label').addClass('active');
					var random = Math.floor((Math.random() * 4));
// 					$("[data-isplenoal15]:eq(1)").find("input[data-value]:eq(" + random + ")").trigger("change");
					$("[data-isplenoal15]:eq(1) input[data-value]:eq(" + random + ")").prop('checked',true).closest('label').addClass('active');
				}

				if(parentObj.hasExtrasOut){ //Elige8 activo
					if(!isMultiple || (isMultiple && !parentObj.isSetToReducida && !parentObj.isSetToCondicionada && !parentObj.isReducidaInProgress && !parentObj.isCondicionadaInProgress)){
						colStatus["col"] = 	colIndexToInject
						var extraNumbers = $("[data-numberschoser] td[data-quinielaColumn][data-columna-extra] label.active").length;
						colStatus["extrasRemaining"] = parentObj.extrasToChooseSN - extraNumbers;
						colStatus["extras"] = extraNumbers;
					}else{
						colStatus["extrasRemaining"] = 0;
						colStatus["extras"] = 0;
					}
				}

				if(!isMultiple){
					colStatus["numbers"] = 14;
					colStatus["numbersRemaining"] = 0;
					colStatus["p15"] = 2;
					colStatus["p15Remaining"] = 0;
				}
				if (index == 0) {
					if(!isMultiple){
						parentObj.isMultipleInProgress=false;

						//Desactivamos el último elemento, y lo reinvocamos mediante el evento "change"
						//Lo hacemos sólo con la primera columna para activar las múltiples si las hubiera

						$(lastNumberIndex).prop('checked',false).closest('.column').removeClass('active');
						$(lastNumberIndex).trigger("change");
						parentObj.onEnableNonMultipleSummaryCallback();
						parentObj.checkColumnasCompletadas();
					}else{
						parentObj.isMultipleInProgress=true;
						parentObj.resetExtraColumns();
						//para dobles
						//Elegimos partidos
						var arrayPartidos=Array();
						var salir=false;
						if( customQuiniDeDos>0){
							while(!salir){
								var random = Math.floor((Math.random() * 14));
								if(!inArray(random,arrayPartidos)){
									arrayPartidos.push(random)
								}
								if(arrayPartidos.length==customQuiniDeDos){
									salir=true;
								}
							}
							for(i=0;i<=arrayPartidos.length;i++){
								//Elegimos partidos
								var casillasLibres=Array();
								var casillasLibresElem=$("[data-numberschoser] tr[data-row='"+arrayPartidos[i]+"'] td[data-quinielaColumn='0'] label[data-value]:not(.active)");
								var randomCasillasLibres = Math.floor((Math.random() * 2));
// 								$(casillasLibresElem).eq(casillasLibres).find('input').trigger("change").closest('td').attr("data-mult-num","2");
								var elem=$(casillasLibresElem).eq(casillasLibres).find('input');
								$(elem).prop('checked',true).closest('label').addClass('active').closest('td').attr("data-mult-num","2");
								lastNumberIndex=$(elem);
// 								trigger("change").closest('td').attr("data-mult-num","2");
							}
						}
						//para triples
						//Elegimos partidos
						var arrayPartidosTriples=Array();
						var arrayPartidosRestantes=Array();
						var salir=false;
						for(i=0;i<14;i++){
							if(!inArray(i,arrayPartidos)){
								arrayPartidosRestantes.push(i);
							}
						}

						if( customQuiniDeTres>0){
							while(!salir){
								var random = Math.floor((Math.random() * arrayPartidosRestantes.length));
								if(!inArray(arrayPartidosRestantes[random],arrayPartidosTriples)){
									arrayPartidosTriples.push(arrayPartidosRestantes[random]);
								}
								if(arrayPartidosTriples.length==customQuiniDeTres){
									salir=true;
								}
							}

							for(i=0;i<=arrayPartidosTriples.length;i++){
								//Elegimos partidos
								var casillasLibres=Array();
								var casillasLibresElem=$("[data-numberschoser] tr[data-row='"+arrayPartidosTriples[i]+"'] td[data-quinielaColumn='0'] label[data-value]:not(.active)");
// 								$(casillasLibresElem).find('input').trigger("change").closest('td').attr("data-mult-num","3");
								var elem=$(casillasLibresElem).find('input');
								$(elem).prop('checked',true).closest('label').addClass('active').closest('td').attr("data-mult-num","3");
								lastNumberIndex=$(elem);
							}
						}
						$(lastNumberIndex).prop('checked',false).closest('label').removeClass('active');
						$(lastNumberIndex).trigger('change');
						parentObj.onDisableNonMultipleSummaryCallback();
						parentObj.onClickedMultipleCallback(parentObj);
					}
					parentObj.onOneNumberSelectedCallback();
					parentObj.onFirstColumnDoneCallback(parentObj);
				}
	 			if(customReduccionId!==false){
	 				var elem=$('[data-reducciones-id='+customReduccionId+']:eq(0)');
					if($(elem).length!=0){
						$(elem).trigger('click');
					}else{
						$('[data-select-personalizada-numero] option').each(function(){
							if($(this).text()==customReduccion){
								$(this).prop('selected',true);
								$(this).parent().trigger('change');
								$('[data-select-personalizada-apuestas] option[data-reducciones-id="'+customReduccionId+'"]').prop('selected',true).parent().trigger('change').closest('tr[data-customMultiple]').trigger('click');
							}
						})
					}
	 			}
				parentObj.markPager('done', index)
				parentObj.boletoSnapshot[parentObj.getActiveColumn()].status = 1;
				if(parentObj.progressiveColumns){
/* 					if(!parentObj.hasExtrasOut || (parentObj.hasExtrasOut && colStatus.extrasRemaining == 0 && (!parentObj.isMultipleInProgress || (parentObj.isMultipleInProgress && parentObj.hasExtrasOut && !parentObj.isReducidaInProgress && !parentObj.isCondicionadaInProgress && !parentObj.isSetToCondicionada && !parentObj.isSetToReducida)))){ */
						parentObj.unblockColumn(parentObj.getActiveColumn()+1);
/* 					} */
				}

			}
			if(!parentObj.isQuiniela){
				parentObj.checkColumnasCompletadas();
				parentObj.onAnyColumnDoneCallback(parentObj);
			}else{
				parentObj.checkColumnasCompletadas();
				if(parentObj.correctBets >= 2){
					parentObj.onAnyColumnDoneCallback(parentObj,colStatus);
				}
			}
			parentObj.isShuffleInProgress = false;
			onMarkedCallback();
		}
}
numberChooser.prototype.setMultipleRawValues = function(options){ //Sirve para añadir elementos a la propiedad "multipleRawValues" desde fuera del objeto
	var parentObj=this;
	this.variantes = new Array();
	this.doses = new Array();
	this.equis = new Array();
	this.idReduccion = false;
	this.apuestas = 0;

// 	parentObj.multipleRawValues= {"idReduccion":idDeReduccion};

	if (typeof options != "undefined"){

		if (typeof options.idReduccion != "undefined") 	{
			this.idReduccion = options.idReduccion;
			parentObj.multipleRawValues["idReduccion"]=this.idReduccion;
		}
		if (typeof options.variantes != "undefined") 	{
			this.variantes = options.variantes;
			parentObj.multipleRawValues["variantes"]=this.variantes;
			parentObj.multipleRawValues["idReduccion"]=false;
		}
		if (typeof options.doses != "undefined") 		{
			this.doses = options.doses
			parentObj.multipleRawValues["doses"]=this.doses;
			parentObj.multipleRawValues["idReduccion"]=false;
		}
		if (typeof options.equis != "undefined")		{
			this.equis = options.equis
			parentObj.multipleRawValues["equis"]=this.equis;
			parentObj.multipleRawValues["idReduccion"]=false;
		}
		if (typeof options.apuestas != "undefined")		{
			this.apuestas = parseInt(options.apuestas);
			parentObj.apuestas=this.apuestas
			parentObj.multipleRawValues["apuestas"]=this.apuestas;
		}
	}
}
numberChooser.prototype.setExtrasRawValues = function(options){//Sirve para añadir elementos a la propiedad "rawApuesta" desde fuera del objeto
	var parentObj=this;
	if (typeof options != "undefined"){
		if (typeof options.joker != "undefined") {
			if(options.joker == true){
				parentObj.rawApuesta["joker"]=1;
			}else{
				parentObj.rawApuesta["joker"]=0;
			}
		}
		if (typeof options.extra != "undefined"){ //se puede pasar como option {extra:[elem,value]}
			parentObj.rawApuesta[options.extra[0]]=options.extra[1]
		}
	}
}
numberChooser.prototype.getRawValues = function(options){
	var parentObj=this;
	//var raw=Object.assign({}, this.rawApuesta);
	if((GetIEVersion()==0 || GetIEVersion()>11) && typeof Object.assign != "undefined"){
		var raw=Object.assign({}, this.rawApuesta);
	}else{
// 		var raw=$.extend(this.rawApuesta);
		var raw = JSON.parse(JSON.stringify(this.rawApuesta));
		function toObject(arr) {
		  var rv = {};
		  for (var i = 0; i < arr.length; ++i)
		    rv[i] = arr[i];
		  return rv;
		}
		raw = toObject(raw);
	}

	var posicionCondicionadas=new Array();
	var condiciones = false;
	var variantes=false;
	var doses=false;
	var equis=false;

	this.exportForCondicionadas=false;
	this.exportNumsAndExtras=false;
	this.exportForAutofill=false;

	if(typeof options != "undefined"){
		if( typeof options.exportForCondicionadas != "undefined"){ this.exportForCondicionadas = options.exportForCondicionadas }
		if( typeof options.exportNumsAndExtras != "undefined"){ this.exportNumsAndExtras = options.exportNumsAndExtras }
		if( typeof options.exportForAutofill != "undefined"){ this.exportForAutofill = options.exportForAutofill }
	}

	if(parentObj.isQuiniela || parentObj.isQuinigol){
		if(parentObj.isMultipleInProgress || parentObj.isReducidaInProgress || parentObj.isCondicionadaInProgress){
			//Extras para reducidas y condicionadas
			for(i=0;i<15;i++){
				var numbers = $("[data-numberschoser] tr[data-row='"+i+"']").find("td[data-quinielacolumn][data-columna-extra][data-index='8']").find("[data-value].active");
				if(numbers.length>0){
					if(typeof raw[0] != "undefined"){
						if(typeof raw[0][i]!="undefined"){
/*
							if(!inArray("*",raw[0][i])){
								raw[0][i].push("*")
							}
*/
							posicionCondicionadas.push(i+1);
						}
					}
				}
			}

			if(typeof parentObj.multipleRawValues.idReduccion !="undefined" && parentObj.multipleRawValues.idReduccion!="reducida" && parentObj.multipleRawValues.idReduccion!="directo"){
				raw["idReduccion"]=parentObj.multipleRawValues.idReduccion;
			}
			if(posicionCondicionadas.length>0){
				raw["condicionadas"]= posicionCondicionadas;
			}
			if(typeof parentObj.multipleRawValues.variantes !="undefined"){
				variantes=raw["variantes"]= parentObj.multipleRawValues.variantes;
			}
			if(typeof parentObj.multipleRawValues.doses !="undefined"){
				doses=raw["doses"]= parentObj.multipleRawValues.doses;
			}
			if(typeof parentObj.multipleRawValues.equis !="undefined"){
				equis=raw["equis"]= parentObj.multipleRawValues.equis;
			}

		}
	}

	//MODOS CUSTOM DE SALIDA
	if(this.exportForCondicionadas){ // Modo TEXTO para lanzar al calculador de condicionadas
		var exportArray=new Array();
		if(typeof raw[0]!="undefined"){
			for(i=0;i<=15;i++){
				exportArray.push(raw[0][i].join(""));
			}
			exportArray=exportArray.join(",");
			if(posicionCondicionadas.length>0){
				raw["condicionadas"]= posicionCondicionadas.join(",");
			}
			if(typeof parentObj.multipleRawValues.variantes !="undefined"){
				raw["variantes"]= parentObj.multipleRawValues.variantes.join(",");
			}
			if(typeof parentObj.multipleRawValues.doses !="undefined"){
				raw["doses"]= parentObj.multipleRawValues.doses.join(",");
			}
			if(typeof parentObj.multipleRawValues.equis !="undefined"){
				raw["equis"]= parentObj.multipleRawValues.equis.join(",");
			}
			condiciones = raw["condicionadas"] + "-" + raw["variantes"] + "-" + raw["equis"] + "-" + raw["doses"];
			return {"0":exportArray,"condiciones":condiciones}
		}
	}

	if(this.exportNumsAndExtras){ // Devuelve array de nums por un lado, array de extras por otro
		var exportArrayNums=new Array();
		var exportArrayExtras=new Array();


		//Quiniela
		if(parentObj.isQuiniela || parentObj.isQuinigol){
			//Multiple reducida
			for( i=0;i<parentObj.rawApuesta.length;i++){
				if(i==0){
					var temp=new Array();
					for(j=0;j<=15;j++){
						temp.push(Array(parentObj.rawApuesta[0][j].join("")));
					}
					exportArrayNums.push(temp)
				}else{
					var temp=new Array();
					for(j=0;j<=13;j++){
						temp.push(Array(parentObj.rawApuesta[i][j]));
					}
					exportArrayNums.push(temp)
				}
			}
			raw={"nums":exportArrayNums}
			if(posicionCondicionadas.length>0){ //Si tiene marcados extras, es al menos reducida
				if(parentObj.isMultipleInProgress && !parentObj.isReducidaInProgress && !parentObj.isCondicionadaInProgress){ //Si no es condicionada ni reducida, pero tiene extras, entonces es una normal o múltiple con elige8
					raw["elige8"]=posicionCondicionadas.map( function(num){ return parseInt(num) } );
				}else{
					raw["extras"]=posicionCondicionadas;
				}
				//Multiple condicionada
				if((variantes && variantes.length>0)||(doses && doses.length>0)||(equis && equis.length>0)){ //Hay condicionada
					var quinielaCondiciones = parentObj.getRawValues({"exportForCondicionadas":true})
					if( typeof quinielaCondiciones != "undefined" || quinielaCondiciones.length>0){
						quinielaCondiciones = quinielaCondiciones["condiciones"];
						raw["condicion"]=quinielaCondiciones;
					}
				}
			}else{
				if(typeof parentObj.rawApuesta["elige8"] != "undefined" && parentObj.rawApuesta["elige8"].length > 0){
					raw["elige8"] = parentObj.rawApuesta["elige8"].map( function(num){ return parseInt(num) } );
				}
			}

		}else{
			var hasJoker=false;
 			for( i=0;i<parentObj.rawApuesta.length;i++){
 				exportArrayNums.push(parentObj.rawApuesta[i]["nums"]);
 				if(typeof parentObj.rawApuesta[i]["extras"] != "undefined"){
	 				exportArrayExtras.push(parentObj.rawApuesta[i]["extras"]);
	 			}
 				if(typeof parentObj.rawApuesta[i]["joker"] != "undefined" && parentObj.rawApuesta[i]["joker"]==1){
	 				hasJoker=1;
	 			}
 			}
 			if(!hasJoker){
	 			raw={"nums":exportArrayNums,"extras":exportArrayExtras}
 			}else{
	 			raw={"nums":exportArrayNums,"extras":exportArrayExtras,"joker":1}
 			}

		}
		if(typeof parentObj.multipleRawValues.idReduccion !="undefined" && parentObj.multipleRawValues.idReduccion!="reducida" && parentObj.multipleRawValues.idReduccion!="directo" && parentObj.multipleRawValues.idReduccion!=false){
			raw["idReduccion"]=parentObj.multipleRawValues.idReduccion;
		}
		if(parentObj.isMultipleInProgress || parentObj.isReducidaInProgress){
			raw["multiple"]="1";
		}

	}
	if(this.exportForAutofill){
		var betsStr = ""
		if(parentObj.isQuiniela || parentObj.isQuinigol){
			var e8 = "";
			$(parentObj.rawApuesta).each(function(k,v){
				if(k != 0){
					betsStr = betsStr + "-"
				}

				if(k == 0){
					$(Object.keys(v)).each(function(j,i){
						if(j != 0){
							betsStr = betsStr + ","
						}
						console.log(i)
						betsStr = betsStr + v[j].join("")
					})
					if(typeof parentObj.rawApuesta.elige8 != "undefined"){
						betsStr = betsStr + "~" + parentObj.rawApuesta.elige8.join(",")
					}
				}else{
					betsStr = betsStr + v.join(",")
				}
			})
			//Buscamos elige8
/*
			if(typeof parentObj.rawApuesta.elige8 != "undefined"){
				e8 = "&elige8="+parentObj.rawApuesta.elige8.join(",")
				betsStr = betsStr + e8;
			}

*/

		}else{
			$(parentObj.rawApuesta).each(function(k,v){
				if(k != 0){
					betsStr = betsStr + "-"
				}
				betsStr = betsStr + v.nums.join(",")
				if (typeof v.extras != "undefined"){
					betsStr = betsStr + "~" + v.extras.join(",")
				}
			})
		}
		return betsStr;
	}
	return raw;

}
numberChooser.prototype.goToFirstBet = function(){
	var parentObj=this;
// 	if(parentObj.currentBet!=0 || !$(".numbersChoserPages li:eq(0)").hasClass('active')){
		parentObj.currentBet=0;
		$(".numbersChoserPages li:eq(0)").trigger("click");
		parentObj.updatePager();
// 	}
}
numberChooser.prototype.areExtrasAlreadyChosen = function(indexForNonExternalExtras){
	var parentObj = this;
	var index = false;
	if(typeof indexForNonExternalExtras != "undefined"){
		index = indexForNonExternalExtras;
	}
	if (parentObj.hasExtras) {
		if(parentObj.hasExtrasOut){
			var extrasElems = $("[data-columna-extra]:eq(0)").find(".column.active label input");
			if($(extrasElems).length >= parentObj.extrasToChooseSN){
				return true;
			}
		}else{
			var extrasElems = $("[data-columna-extra]:eq(" + index + ")").find(".column label input");
			if($(extrasElems).length >= parentObj.extrasToChooseSN){
				return true;
			}
		}

	}
	return false;
}


numberChooser.prototype.setBet = function(betObj,options){

	//Establece una apuesta manualmente
	//betObj:
	// {
	// 	0:{nums:[2,3,30,5,15],extras:[2,3],idReduccion:"xxxx",optimizadaAl:2(sólo si es fórmula personalizada)},
	// 	1:{nums:[2,5,6,7,8],extras:[1,7]}
	// }
	// Para Quiniela
	//{
	//0:{nums:[["1","X"],["1","X","2"],["1"],["1"],["1"],["2"],["1","2"],["1","X"],["X"],["X"],["1","2"],["1"],["1"],["X"],["M"],["2"]],idReduccion:"1018",condicionadas:[2,3,4],variantes:[0,1],doses:[0,1,2,3],equis:[0,1,2,3,4],elige8:[1,2,3,4,5,6,7,8]},
	//1:{nums:["2","2","2","2","2","2","1","1","1","1","1","1","2","x"]}
	//}
	var parentObj=this;
	var strings = {
		bets: "apuestas",
		processing: "caculando"
	}

	var onBeforeSettingMultiplesExtrasCallback=function(){} //lanza callback justo antes de empezar a marcar los extras en las múltiples

	if(typeof options != "undefined"){
		if (typeof options.strings != "undefined"){
			if (typeof options.strings.bets != "undefined") { strings.bets = options.strings.bets}
			if (typeof options.strings.processing != "undefined") { strings.processing = options.strings.processing}
		}
	}

	parentObj.resetBoleto();
	if(!parentObj.isQuiniela){

		var apuestaIndex=0;
		var lastNumberIndex = false;
		var lastExtraIndex = false;
		var lastRowIndex = false;
		var numsInFirstBet = 0;
		var extrasInFirstBet = 0;
		var reduccionId = false;
		var reduccionCustom = false;
		var hasMultipleInFirstBet = false;
		var hasJoker= false;

 		$(Object.keys(betObj)).each(function(value){
 			if(typeof betObj[value].nums != "undefined"){
	 	 		$(betObj[value].nums).each(function(apuestaIndex,numerosArray){
		 	 		if(!hasMultipleInFirstBet || value==0){
						var elem=$("[data-numberschoser] [data-columna]").find("div.row[data-index=" + value + "] .column label[data-value="+numerosArray+"]");
						$(elem).find('input').prop('checked',true).closest('.column').addClass('active');
					}
					if(value==0){
						lastNumberIndex = numerosArray;
						numsInFirstBet = betObj[value].nums.length;
						if(numsInFirstBet>parentObj.betsToChooseSN){
							hasMultipleInFirstBet = true;
						}
					}
				})
			}
 			if(typeof betObj[value].extras != "undefined"){
	 	 		$(betObj[value].extras).each(function(apuestaIndex,extrasArray){
		 	 		if(!hasMultipleInFirstBet || value==0){
						var elem=$("[data-numberschoser] [data-columna-extra]").find("div.row[data-index=" + value + "] .column label[data-value="+extrasArray+"]");
						$(elem).find('input').prop('checked',true).closest('.column').addClass('active');
					}
					if(value==0){
						lastExtraIndex = extrasArray;
						extrasInFirstBet = betObj[value].extras.length;
						if(typeof parentObj.extrasToChooseSN !="undefined" && extrasInFirstBet > parentObj.extrasToChooseSN){
							hasMultipleInFirstBet = true;
						}
					}
				})
	 		}
	 		if(typeof betObj[value].joker != "undefined" && betObj[value].joker ==1){
		 		hasJoker=true;
	 		}
 			if(typeof betObj[value].idReduccion != "undefined"){
	 			reduccionId=betObj[value].idReduccion;
	 		}
 			if(typeof betObj[value].optimizadaAl != "undefined"){
	 			reduccionCustom=betObj[value].optimizadaAl;
	 		}
	 		lastRowIndex = value;
		})
		if(lastNumberIndex!==false && lastRowIndex!==false){
			parentObj.goToFirstBet()
			//Desactivamos el último elemento, y lo reinvocamos mediante el evento "change"
			//Lo hacemos sólo con la primera columna para activar las múltiples si las hubiera
			var elem=$("[data-numberschoser] [data-columna]").find("div.row[data-index='0'] .column label[data-value="+lastNumberIndex+"] input");
			$(elem).prop('checked',false).closest('.column').removeClass('active');

			if(hasMultipleInFirstBet ){
				//Existen múltiples
				parentObj.allowMultipleBackup = parentObj.allowMultiple;
				parentObj.setAllowMultiple(true);
				parentObj.isMultipleInProgress=true;
				parentObj.onDisableNonMultipleSummaryCallback(parentObj.checkColumnasCompletadas());
			}else{
				parentObj.setAllowMultiple(parentObj.allowMultipleBackup ?? parentObj.allowMultiple);
				parentObj.isMultipleInProgress=false;
				parentObj.onEnableNonMultipleSummaryCallback();
			}
			$(elem).parent('label').trigger('click')
			if(hasJoker){
				$('[data-joker]').addClass('is-active').find('input').prop('checked',true);
				$('[data-joker]').trigger('change')
				parentObj.setExtrasRawValues( { joker:true })

			}else{
				$('[data-joker]').removeClass('is-active').find('input').prop('checked',false);
				$('[data-joker]').trigger('change')
				parentObj.setExtrasRawValues( { joker:false })
			}
			parentObj.checkColumnasCompletadas();
			if(reduccionId!==false){
				var elem=$('[data-reducciones-option][data-reducciones-id='+reduccionId+']:eq(0)');
				if($(elem).length==0){
					$('[data-select-personalizada-numero] option').each(function(){
						if($(this).text()==reduccionCustom){
							$(this).prop('selected',true);
							$(this).parent().trigger('change');
							$('[data-select-personalizada-apuestas] option[data-reducciones-id="'+reduccionId+'"]').prop('selected',true).parent().trigger('change').closest('tr[data-customMultiple]').trigger('click');
						}
					})
				}else{
	 				$(elem).trigger('click');
				}
	 		}
		}
	}else{
		var lastNumberIndex = false;
		var lastMatchIndex = false;
		var hasMultipleInFirstBet = false;
		var reduccionId = false;
		var lastCondicionadaElem=false;
		var lastCondicionElem=false;
		var elige8=false;
		var isRed=false;
		var isCond=false;
		var isMult=false;

 		$(Object.keys(betObj)).each(function(value){
 			if(typeof betObj[value].idReduccion != "undefined"){
	 			reduccionId=betObj[value].idReduccion;
	 		}
 			if(typeof betObj[value].nums != "undefined"){
	 	 		$(betObj[value].nums).each(function(apuestaIndex,numerosArray){
		 	 			if(value==0){
							if(numerosArray.length>1){
								hasMultipleInFirstBet=true; //Tiene múltiples
								parentObj.allowMultipleBackup = parentObj.allowMultiple;
								parentObj.setAllowMultiple(true);
							}
							$(numerosArray).each(function(index,casilla){
								if(casilla.toLowerCase()=="x"){
									casilla="x";
								}else if(casilla.toLowerCase()=="m"){
									casilla="M";
								}
								var elem=$("[data-numberschoser] tr[data-row="+apuestaIndex+"] [data-quinielacolumn][data-index=" + value + "] label[data-value="+casilla+"]");
								$(elem).addClass('active').find('input').prop('checked',true);
								lastNumberIndex=casilla;
								lastMatchIndex=apuestaIndex;

							})

						}else{
							if(!hasMultipleInFirstBet){
								parentObj.setAllowMultiple(parentObj.allowMultipleBackup ?? parentObj.allowMultiple);
								if(numerosArray.toLowerCase()=="x"){
									numerosArray="x";
								}else if(numerosArray.toLowerCase()=="m"){
									numerosArray="M";
								}
								var elem=$("[data-numberschoser] tr[data-row="+apuestaIndex+"] [data-quinielacolumn][data-index=" + value + "] label[data-value="+numerosArray+"]");
								$(elem).addClass('active').find('input').prop('checked',true);
							}
						}


				})
			}
 			if(typeof betObj[value].idReduccion != "undefined"){
	 			reduccionId=betObj[value].idReduccion;
	 		}
 			if(typeof betObj[value].optimizadaAl != "undefined"){
	 			reduccionCustom=betObj[value].optimizadaAl;
	 		}
 			if(typeof betObj[value].extras != "undefined"){
	 			elige8=betObj[value].extras;
	 			if(elige8){
					$('[data-extraGame]').addClass('is-active').find('input').prop('checked',true);
					$('[data-extraGame]').trigger('change')
					$(elige8).each(function(k,v){
						var elem=$("[data-numberschoser] [data-quinielacolumn][data-columna-extra] label[data-value="+v+"]");
						$(elem).addClass('active').find('input').prop('checked',true);
					})
				}
	 		}


		})


		if(lastNumberIndex!==false && lastMatchIndex!==false){
			parentObj.goToFirstBet()
			//Desactivamos el último elemento, y lo reinvocamos mediante el evento "change"
			//Lo hacemos sólo con la primera columna para activar las múltiples si las hubiera
			var elem=$("[data-numberschoser] tr[data-row="+lastMatchIndex+"] [data-quinielacolumn][data-index='0'] label[data-value="+lastNumberIndex+"] input");
			$(elem).prop('checked',false).closest('label').removeClass('active');
			if(hasMultipleInFirstBet){
				$(Object.keys(betObj)).each(function(value){
					if(hasMultipleInFirstBet && value==0){
					 	if(typeof betObj[value].condicionadas != "undefined"){ //Si es reducida o condicionada
						 	parentObj.isReducidaInProgress=true;
							  isRed=true;

							if(typeof betObj[value].doses != "undefined" && typeof betObj[value].equis != "undefined" && typeof betObj[value].variantes != "undefined"){ //Si es condicionada
							 	parentObj.isReducidaInProgress=false;
							 	parentObj.isCondicionadaInProgress=true;
							 	isCond=true;
							 	isRed=false;
							}else if(typeof betObj[value].doses == "undefined" && typeof betObj[value].equis == "undefined" && typeof betObj[value].variantes == "undefined"){ //Si es reducida
							 	parentObj.isReducidaInProgress=true;
							 	parentObj.isCondicionadaInProgress=false;
							 	 isRed=true;
							 	 isCond=false;
							}
					 	}else{ //Es múltiple normal
							parentObj.isMultipleInProgress=true;
						 	parentObj.isReducidaInProgress=false;
						 	parentObj.isCondicionadaInProgress=false;
						 	 isRed=false;
						 	 isCond=false;
						 	 isMult=true;

					 	}

					}
				})
			}
			if(hasMultipleInFirstBet){

				if(isCond){ //condicionada
					parentObj.onDisableNonMultipleSummaryCallback(parentObj.checkColumnasCompletadas());
					//Hay que lanzar el cálculo de condicionadas
				}else if(isRed){ //reducida
					parentObj.onDisableNonMultipleSummaryCallback(parentObj.checkColumnasCompletadas());
				}else if(isMult){ //Múltiples normales
					parentObj.onDisableNonMultipleSummaryCallback(parentObj.checkColumnasCompletadas());
					$(elem).trigger("change");
					parentObj.checkColumnasCompletadas();
					if(reduccionId!==false){	 //Si hay reducciones
						var elem=$('[data-reducciones-option][data-reducciones-id='+reduccionId+']:eq(0)');
						if($(elem).length==0){
							$('[data-select-personalizada-numero] option').each(function(){
								if($(this).text()==reduccionCustom){
									$(this).prop('selected',true);
									$(this).parent().trigger('change');
									$('[data-select-personalizada-apuestas] option[data-reducciones-id="'+reduccionId+'"]').prop('selected',true).parent().trigger('change').closest('tr[data-customMultiple]').trigger('click');
								}
							})
						}else{
							$(elem).trigger('click');
						}
					}
				}

				if( isRed==true || isCond==true ){ //acciones comunes para multiples condicionadas y reducidas
					$(betObj['0'].condicionadas).each(function(key,value){ //Marcamos los extras si los tiene (columna en red y cond)
						var elemCondiciones=$('[data-quinielaColumn="8"][data-columna-extra] input[data-value="'+value+'"]');
						$(elemCondiciones).removeAttr('disabled').parent('label').addClass('active').removeClass('disabled');
						if($(elemCondiciones).length>0){
							lastCondicionElem=$(elemCondiciones);
					 	}
					})
					$(elem).trigger("change");

					$(lastCondicionElem).prop('checked',false).removeClass('is-active').parent('label').removeClass('active');
					$(lastCondicionElem).trigger('change')
					if(isCond){
				 		parentObj.isReducidaInProgress=false;
					}

					parentObj.checkColumnasCompletadas()
					parentObj.onClickedMultipleCallback(parentObj)
					if(isCond==true){
						$(betObj['0'].doses).each(function(key,value){
						   var condElem=$('input[name="doses"][data-value="'+value+'"]');
						   $(condElem).prop('checked',true).removeAttr('disabled').parent('label').removeClass('disabled').addClass('is-active');
						   if($(condElem).length>0){
						 		lastCondicionadaElem=$(condElem);
						   }
						})
						$(betObj['0'].equis).each(function(key,value){
						   var condElem=$('input[name="equis"][data-value="'+value+'"]');
						   $(condElem).prop('checked',true).removeAttr('disabled').parent('label').removeClass('disabled').addClass('is-active');
						 	if($(condElem).length>0){
						 		lastCondicionadaElem=$(condElem);
						   }
						})
						$(betObj['0'].variantes).each(function(key,value){
						   var condElem=$('input[name="variantes"][data-value="'+value+'"]');
						   $(condElem).prop('checked',true).removeAttr('disabled').parent('label').removeClass('disabled').addClass('is-active');
						   if($(condElem).length>0){
						 		lastCondicionadaElem=$(condElem);
						   }
						})
						calculaCondicionadas(parentObj,{
							strings: strings
						})
					}

					$(lastCondicionadaElem).trigger('change')
				}
			}else{ //Normal

				parentObj.onEnableNonMultipleSummaryCallback();
				$(elem).trigger("change");
				parentObj.checkColumnasCompletadas();
			}
		}
	}
}
numberChooser.prototype.blockColumn = function(column){
	var self = this;

	if(!self.isQuiniela && !self.isQuinigol){
		var elem = $('[data-numberschoser] [data-columna] [data-index="' + column + '"]');
		$(elem).closest('[data-columna]').addClass('disabled').attr('aria-disabled',true)
		$(elem).addClass('disabled');
		$(elem).add($(elem).parent()).find('input').attr('disabled','disabled').attr('aria-disabled',true)

		if(self.hasExtras && !self.extrasUnique){
			var elemExtras = $('[data-numberschoser][data-extraschooser] [data-columna-extra] [data-index="' + column + '"]');
			$(elemExtras).closest('[data-columna-extra]').addClass('disabled').attr('aria-disabled',true);
			$(elemExtras).addClass('disabled').attr('aria-disabled',true);
			$(elemExtras).find('input').attr('disabled','disabled').attr('aria-disabled',true)
		}
	}else{
		var elem = $('[data-numberschoser] [data-quinielaColumn][data-index="' + column + '"]');
		$(elem).addClass('disabled').attr('aria-disabled',true)
		$(elem).find('input').attr('disabled','disabled').attr('aria-disabled',true)
	}
}
numberChooser.prototype.unblockColumn = function(column){
	var self = this;
	if(!self.isQuiniela && !self.isQuinigol){
		var elem = $('[data-numberschoser] [data-columna] [data-index="' + column + '"]');
		$(elem).closest('[data-columna]').removeClass('disabled').removeAttr('aria-disabled')
		$(elem).removeClass('disabled').removeAttr('aria-disabled');
		$(elem).find('input').removeAttr('disabled').removeAttr('aria-disabled');
		$(elem).add($(elem).parent()).find('button').removeAttr('disabled').removeAttr('aria-disabled');

		if(self.hasExtras && !self.extrasUnique){
			var elemExtras = $('[data-numberschoser][data-extraschooser] [data-columna-extra] [data-index="' + column + '"]');
			$(elemExtras).closest('[data-columna-extra]').removeClass('disabled').removeAttr('aria-disabled')
			$(elemExtras).removeClass('disabled').removeAttr('aria-disabled');
			$(elemExtras).find('input').removeAttr('disabled').removeAttr('aria-disabled');
			$(elemExtras).find('button').removeAttr('disabled').removeAttr('aria-disabled')
		}
	}else{
		var elem = $('[data-numberschoser] [data-quinielaColumn][data-index="' + column + '"]');
		$(elem).removeClass('disabled').removeAttr('aria-disabled');
		$(elem).find('input').removeAttr('disabled').removeAttr('aria-disabled');
		$(elem).find('button').removeAttr('disabled').removeAttr('aria-disabled');
	}

}
numberChooser.prototype.blockAllColumns = function(columnToIgnoreBlock){
	var self = this;
	if(!self.isQuiniela && !self.isQuinigol){
		var elem = $('[data-numberschoser] [data-columna]');
		$(elem).closest('[data-columna]').addClass('disabled').attr('aria-disabled',true)
		$(elem).addClass('disabled').attr('aria-disabled',true);
		$(elem).find('input').attr('disabled','disabled').attr('aria-disabled',true)
		$(elem).find('button').attr('disabled','disabled').attr('aria-disabled',true)

		if(self.hasExtras && !self.extrasUnique){
			var elemExtras = $('[data-numberschoser][data-extraschooser] [data-columna-extra]');
			$(elemExtras).addClass('disabled').attr('aria-disabled',true);
			$(elemExtras).find('input').attr('disabled','disabled').attr('aria-disabled',true)
		}
	}else{
		var elem = $('[data-numberschoser] [data-quinielaColumn]:not([data-columna-extra])');
		$(elem).addClass('disabled').attr('aria-disabled',true);
		$(elem).find('input').attr('disabled','disabled').attr('aria-disabled',true)
		$(elem).find('button').attr('disabled','disabled').attr('aria-disabled',true)

	}
	this.unblockColumn(columnToIgnoreBlock);
}

numberChooser.prototype.unblockAllColumns = function(){
	var self = this;
	if(!self.isQuiniela && !self.isQuinigol){

		var elem = $('[data-numberschoser] [data-columna]');
		$(elem).closest('[data-columna]').removeClass('disabled')
		$(elem).removeClass('disabled');
		$(elem).find('input').removeAttr('disabled')
		$(elem).find('button').removeAttr('disabled')

		if(self.hasExtras && !self.extrasUnique){
			var elemExtras = $('[data-numberschoser][data-extraschooser] [data-columna-extra]');
			$(elemExtras).removeClass('disabled');
			$(elemExtras).find('input').removeAttr('disabled')
		}
	}else{
		var elem = $('[data-numberschoser] [data-quinielaColumn]:not([data-columna-extra])');
		$(elem).removeClass('disabled');
		$(elem).find('input').removeAttr('disabled')
		$(elem).find('button').removeAttr('disabled')

	}
}


numberChooser.prototype.getActiveColumn = function(){
	return parseInt(this.currentRow);
}
numberChooser.prototype.purgeEmptyColumns = function(){
	//si se borra una columna, y están activas las columnas progresivas, purga las vacías más a la derecha
	var parentObj = this;
	var blockEmptyElements = new Array();
	for(i=parseInt(Object.keys(parentObj.boletoSnapshot).length - 1); i >= 0; i--){
		if(parentObj.boletoSnapshot[i].status == 0 && (typeof parentObj.boletoSnapshot[i-1] != "undefined" &&  parentObj.boletoSnapshot[i-1].status == 0)){
			blockEmptyElements.push(i);
		}else{
			break;
		}
	}
	$(blockEmptyElements).each(function(){
		parentObj.blockColumn(this);
	})
}
numberChooser.prototype.getCorrectColumns = function(returnAsObj){
	//La llamada a esta función es muy pesada, cuando se ejecuta se almacena una cache accesible con getColumnasCompletadasCache().
	//Usar la cache siempre que sea posible para consultar. Usar este método cuando haya que hacer cálculos sobre cambios en los números.
	return this.checkColumnasCompletadas(returnAsObj);
}
numberChooser.prototype.getColumnasCompletadasCache = function(){
	//Como llamar a getCorrectColumns es muy pesado, se usa este método que accede a los datos guardados de una consulta previa a getCorrectColumns o checkColumnasCompletadas.
	//Usar esta cache para consultar valores siempre (normalmente en los callbacks) y cuando se hayan establecido con getCorrectColumns antes (que suele hacerse en la lógica de la clase)
	return  this.checkColumnasCompletadasCache;
}

numberChooser.prototype.setAllowMultiple =  function(value){
	if(value === true){
		this.allowMultiple = true;
		if (this.type == "bonoloto" || this.type == "primitiva") {
			this.allowsMultipleWithLess = this.allowsMultipleWithLessBackup;
		}
	} else if (value === false) {
		this.allowMultiple = false;
		if (this.type == "bonoloto" || this.type == "primitiva") {
			this.allowsMultipleWithLess = false;
		}
	}
}

numberChooser.prototype.getAllowMultiple = function(){
	return this.allowMultiple;
}

/**************************/
/** FUNCIONES AUXILIARES **/
/**************************/

function inArray(needle, haystack) {
    var length = haystack.length;
    for(var i = 0; i < length; i++) {
        if (haystack[i] == needle) return true;
    }
    return false;
}

function getCookie(c_name) {
	if (document.cookie.length>0){
		var c_start = document.cookie.indexOf(c_name + "=");
		if (c_start != -1){
			c_start = c_start + c_name.length + 1;
			var c_end = document.cookie.indexOf(";",c_start);
			if(c_end == -1) c_end=document.cookie.length;
			return unescape(document.cookie.substring(c_start,c_end));
		}else{
			return false;
		}
	}else{
		return false;
	}
}

function setCookieNoRoot(cname, cvalue, extraTime) {
	var d = new Date();
	d.setTime(d.getTime() + (extraTime));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";";
}

function GetIEVersion() {
  var sAgent = window.navigator.userAgent;
  var Idx = sAgent.indexOf("MSIE");

  // If IE, return version number.
  if (Idx > 0)
    return parseInt(sAgent.substring(Idx+ 5, sAgent.indexOf(".", Idx)));

  // If IE 11 then look for Updated user agent string.
  else if (!!navigator.userAgent.match(/Trident\/7\./))
    return 11;

  else
    return 0; //It is not IE
}
/******************************/
/** FIN FUNCIONES AUXILIARES **/
/******************************/

function setCookieCombinacion(tipojuego, combinacion) {
	if (tipojuego == 6) {
		if (getCookie("combinacion") != "" || typeof combinacion !== 'undefined') {
			if (typeof combinacion === 'undefined') {
				var cookieCombinacion = getCookie("combinacion");
			} else {
				var cookieCombinacion = combinacion;
			}
			setCookieNoRoot("combinacion", "", -1);
			var combinaciones = cookieCombinacion.split("#");
			$("#numbersChoserSummary").find("td").addClass("disabled");
			for (k=0;k<combinaciones.length;k++) {
				if (combinaciones[k] != "") {

					var combinacionB = combinaciones[k].split(":");
					var indexCombinacion = parseFloat(combinacionB[0]) + 1;

					$("[data-numberschoser]").find("tr").find("td,th").removeClass("active");
					$("[data-numberschoser]").find("tr").find("td:eq(" + (indexCombinacion + 1) + ")").addClass("active");
					$("[data-numberschoser]").find("tr").find("th:eq(" + (indexCombinacion + 1) + ")").addClass("active");

					var matches = combinacionB[1].split(",");
					for (j=0;j<matches.length;j++) {
						if (matches[j] != "") {
							var results = matches[j].split("-");
							var pos = parseFloat(results[0])
							$("[data-numberschoser]").find("tr:eq(" + (pos) + ")").find("td:eq(" + (indexCombinacion + 1) + ") label[data-value='" + results[1] + "']").click();
						}
					}
				}
			}
			$("[data-numberschoser]").find("tr").find("td,th").removeClass("active");
			$("[data-numberschoser]").find("tr").find("td:eq(3),th:eq(3)").addClass("active");
		}
	} else if (tipojuego == 5) {
		if (getCookie("combinacion") != "" || typeof combinacion !== 'undefined') {
			if (typeof combinacion === 'undefined') {
				var cookieCombinacion = getCookie("combinacion");
			} else {
				var cookieCombinacion = combinacion;
			}
			setCookieNoRoot("combinacion", "", -1);
			var combinaciones = cookieCombinacion.split("#");
			$("#numbersChoserSummary").find("td").addClass("disabled");
			for (k=0;k<combinaciones.length;k++) {
				if (combinaciones[k] != "") {

					var combinacionB = combinaciones[k].split(":");
					var indexCombinacion = parseFloat(combinacionB[0]) + 1;

					$("[data-numberschoser]").find("tr").find("td").removeClass("active");
					$("[data-numberschoser]").find("tr").find("td:eq(" + (indexCombinacion + 3) + ")").addClass("active");

					var matches = combinacionB[1].split(",");
					for (j=0;j<matches.length;j++) {
						if (matches[j] != "") {
							var results = matches[j].split("-");
							var pos = parseFloat(results[0])
							$("[data-numberschoser]").find("tr:eq(" + (pos) + ")").find("td:eq(" + (indexCombinacion + 3) + ") label[data-value='" + results[1] + "']").click();
						}
					}
				}
			}
			$("[data-numberschoser]").find("tr").find("td,th").removeClass("active");
			$("[data-numberschoser]").find("tr").find("td:eq(4),th:eq(4)").addClass("active");
		}
	} else {
		if (getCookie("combinacion") != "" || typeof combinacion !== 'undefined') {
			if (typeof combinacion === 'undefined') {
				var cookieCombinacion = getCookie("combinacion");
			} else {
				var cookieCombinacion = combinacion;
			}
			setCookieNoRoot("combinacion", "", -1);
			var combinaciones = cookieCombinacion.split("#");
			$("#numbersChoserSummary").find("tr").addClass("disabled");
			for (k=0;k<combinaciones.length;k++) {
				if (combinaciones[k] != "") {
					var combinacionB = combinaciones[k].split(":");
					var indexCombinacion = combinacionB[0];

					$("[data-numberschoser]").find("div.row.active").removeClass("active");
					$("[data-numberschoser]").find("div.row:eq(" + indexCombinacion + ")").addClass("active");
					$("#numbersChoserSummary").find("tr:eq(" + indexCombinacion + ")").removeClass("disabled");

					var combinacion = combinacionB[1].split(",");
					var numbers = combinacion[0].split("-");
					for (j=0;j<numbers.length;j++) {
						if (numbers[j] != "") {
							$("[data-numberschoser]:not([data-extraschooser])").find("div.row:eq(" + indexCombinacion + ") [data-value='" + numbers[j] + "']").parent().click();
						}
					}
					var extras = combinacion[1].split("-");
					for (j=0;j<extras.length;j++) {
						if (extras[j]) {
							$("[data-extraschooser]").find("div.row:eq(" + indexCombinacion + ") [data-value='" + extras[j] + "']").parent().click();
						}
					}
				}
			}
			$("[data-numberschoser]").find("div.row.active").removeClass("active");
			$("[data-numberschoser]").find("div.row:eq(0)").addClass("active");
		}
	}
}